
"use client";

import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { motion, Variants } from 'framer-motion';
import 'swiper/css';
import 'swiper/css/pagination';
import Image from "next/image";
import { addtowishlist } from "@/clicks/wishlistClicks";
import { axiosGetWishlist } from "@/utilities/axioscall";
import { useRouter } from "next/navigation";
import Link from "next/link";
import dynamic from "next/dynamic";
import TestimonialSection from "./TestimonialSection";


const Homepage = ({
  categoryListData,
  featuredcategoriesListData,
  bestsellersListData,
  topratedListData,
}: {
  categoryListData: any;
  featuredcategoriesListData: any;
  bestsellersListData: any;
  topratedListData: any;
}) => {
  const [pageinit, setPageInit] = useState(false);
  const [count, setCount] = useState<number>(1);
  const [productwishlistData, setproductwishlistData] = useState<any[]>([]);
  const router = useRouter();
  const navigate = (moveon: string) => {
    router.push(moveon);
  };
  const [activeCategory, setActiveCategory] = useState(0); // Start with index 0 for "Men"
  console.log(featuredcategoriesListData, "featuredcategoriesListData list")

  // const textItems = Array(6).fill('MADE IN TAMILNADU');

  // Define parent variants with explicit type
  const scrollVariants: Variants = {
    initial: { x: 0 },
    animate: {
      x: -1000, // Adjust based on content width
      transition: {
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: 20,
          ease: 'linear',
        },
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  };

  // Define child variants with explicit type
  const textVariants: Variants = {
    initial: { opacity: 0, y: 20 },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  const ShopbyCategory = [
    'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/Co32dPgSe06xodVOclGXOasBDNmTbu5N7loAbSGS.webp',
    'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/9zXQwJJlD7IMs2HtjOZBwX2BeCzkbUq2IMLpq1G2.webp',
    'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/URG0GWuyF4vz6oFeqzbBfhz3d0rNFh8oMGUlJMfT.webp',
    'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/bRAHg76hv8JaS6scX1md4uo1AXRJ9YKck4A7IrHm.webp',
    'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/vlifHoqn3giz1yRy5bbLtwoVuGx1zUPXlAK9UsEI.webp',
    'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/j0S9NLt0Eizyt9CM2Tv1pSo9aKeabnBWGfMWQggM.webp',
    'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/2cTg72REXvQunzRUo3qwQXvIjfmCJpOmSs0zKAdr.webp',
    'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/epZ5CGf0eqOznbP5VjlZnPYWwdpNhS29JN4n5WDY.webp',
  ];

  // const categories = [
  //   { name: 'Men', index: 0 },
  //   { name: 'Women', index: 1 },
  //   { name: 'Couple Tshirts', index: 2 },
  //   { name: 'Apparels', index: 3 },
  // ];

  const [isMobile, setIsMobile] = useState(false); // Track mobile state

  // Detect screen size client-side
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobile);
    };
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!pageinit) {
    // console.log("location?.state?.parentid")
    // console.log()
    // console.log("blogData", blogData)
    setPageInit(true);
    axiosGetWishlist(setproductwishlistData);

  }


  // console.log("categoryListData", categoryListData, "featuredcategoriesListData", featuredcategoriesListData, "bestsellersListData", bestsellersListData, "topratedListData",
  // topratedListData,)
  const mainCategories = categoryListData
    ?.sort((a: any, b: any) => {
      return a.sortorder - b.sortorder;
    })
    .filter((category: any) => category.parent_id === 0);
  // Then, sort the main categories based on their IDs
  mainCategories?.sort((a: any, b: any) => a.id - b.id);

  // Dynamically import html-react-parser with SSR disabled
  const parse = dynamic(() => import("html-react-parser").then((mod) => mod.default), {
    ssr: false,
  });


  const deskimages = [
    "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/uploads/Ju30XGTrosB4Ae62lAukr544tYVaH2I8TGBG03iq.webp",
    "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/uploads/Ju30XGTrosB4Ae62lAukr544tYVaH2I8TGBG03iq.webp"];
  const mobileimages = [
    "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/uploads/gqkO9erzIfVv4S1vwGf1Wen6wZ0XzkVpx93aSMCM.webp",
    "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/uploads/gqkO9erzIfVv4S1vwGf1Wen6wZ0XzkVpx93aSMCM.webp"];


  const textItems = [
    "Buy 2 Get 10% Off",
    "Buy 2 Get 10% Off",
    "Buy 2 Get 10% Off",
    "Buy 2 Get 10% Off",
    "Buy 2 Get 10% Off",
    "Buy 2 Get 10% Off",
  ];


  const collections = [
    {
      id: 1,
      title: "Maternity Kurtis",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/63d74a22ae0790ec83637bb31353df40bd215a41?width=788"
    },
    {
      id: 2,
      title: "Maternity Loungewear",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/e43aee2dd53908ee49227b76833920cdf016561e?width=788"
    },
    {
      id: 3,
      title: "Kurtis & Dreams",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/85faa3f44c5c76e59a7565819ab2828ed810e60b?width=788"
    },
    {
      id: 4,
      title: "Breastfeeding Friendly Tops",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/a1aa49aabf0b251488f57673e0440b1e9ca0d83b?width=788"
    },
    {
      id: 5,
      title: "Maternity Kurtis",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/8f9adf3450b2fdc0ed4d100f952f19b4bbc218ce?width=788"
    },
    {
      id: 6,
      title: "Maternity Loungewear",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/2009cb857de032d8ea8caf919e3c77103a9e3e79?width=788"
    },
    {
      id: 7,
      title: "Kurtis & Dreams",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/c5cb6224c73012e27547355065b863efbfab0f84?width=788"
    },
    {
      id: 8,
      title: "Breastfeeding Friendly Tops",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/27e435de3437c5f2c991a41496d54ef45995799f?width=788"
    }
  ];

  const [selectedSize, setSelectedSize] = useState("S");

  const sizes = ["S", "M", "L", "XL", "XXL"];

  const products = [
    {
      id: 1,
      name: "Pranitha Maternity Dress",
      originalPrice: 1600,
      salePrice: 1450,
      savings: 150,
      stock: "4 Pieces Left",
      badge: "Best Seller",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/6bb703e12f8de349468f3244f6fdbd406cae2b30?width=788",
      sizes: "S M L XL XXL"
    },
    {
      id: 2,
      name: "Pranitha Maternity Dress",
      originalPrice: 1600,
      salePrice: 1450,
      savings: 150,
      stock: "4 Pieces Left",
      badge: "Best Seller",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/366ded4003b4c1837dc37e5805d8cb8e4549ab91?width=788",
      sizes: "S M L XL XXL"
    },
    {
      id: 3,
      name: "Pranitha Maternity Dress",
      originalPrice: 1600,
      salePrice: 1450,
      savings: 150,
      stock: "12 Pieces Left",
      badge: "Best Seller",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/1c8cad601c165734f26e68d49cdbc0959503e766?width=788",
      sizes: "S M L XL XXL"
    },
    {
      id: 4,
      name: "Pranitha Maternity Dress",
      originalPrice: 1600,
      salePrice: 1450,
      savings: 150,
      stock: "4 Pieces Left",
      badge: "Best Seller",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/8a2aac947d8e4e5b67b691ae8a547c5e7abed96e?width=788",
      sizes: "S M L XL XXL"
    },
    {
      id: 5,
      name: "Pranitha Maternity Dress",
      originalPrice: 1600,
      salePrice: 1450,
      savings: 150,
      stock: "4 Pieces Left",
      badge: "Best Seller",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/8a2aac947d8e4e5b67b691ae8a547c5e7abed96e?width=788",
      sizes: "S M L XL XXL"
    },
    {
      id: 6,
      name: "Pranitha Maternity Dress",
      originalPrice: 1600,
      salePrice: 1450,
      savings: 150,
      stock: "4 Pieces Left",
      badge: "Best Seller",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/8a2aac947d8e4e5b67b691ae8a547c5e7abed96e?width=788",
      sizes: "S M L XL XXL"
    },
  ];


  return (
    <>


      <div className="overflow-hidden">

        <div className="!relative w-full">
          {/* Desktop Swiper */}
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{
              clickable: true,
              el: ".desktop-custom-dots",
              bulletClass: "custom-bullet",
              bulletActiveClass: "swiper-pagination-bullet-active",
            }}
            loop={true}
            className="w-full !hidden md:!block"
          >
            {deskimages.map((src, index) => (
              <SwiperSlide key={index}>
                <div className="relative w-full">
                  <Image
                    src={src}
                    alt={`Hero Slide ${index + 1}`}
                    width={1920} // adjust width as per your design
                    height={1080} // adjust height as per your design
                    className="w-full h-auto object-contain"
                    priority={index === 0}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Mobile Swiper */}
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{
              clickable: true,
              el: ".mobile-custom-dots",
              bulletClass: "custom-bullet",
              bulletActiveClass: "swiper-pagination-bullet-active",
            }}
            loop={true}
            className="w-full md:!hidden !block"
          >
            {mobileimages.map((src, index) => (
              <SwiperSlide key={index}>
                <div className="relative w-full">
                  <Image
                    src={src}
                    alt={`Hero Slide ${index + 1}`}
                    width={768} // adjust width for mobile
                    height={1024} // adjust height for mobile
                    className="w-full h-auto object-cover"
                    priority={index === 0}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="mx-auto flex justify-center items-center ">
            {/* Desktop dots */}
            <div className="absolute md:bottom-6 bottom-2 z-10 md:flex gap-[6px] desktop-custom-dots hidden left-1/2 -translate-x-1/2"></div>
          </div>

          {/* Mobile dots */}
          <div className="absolute md:bottom-6 bottom-2 z-10 flex gap-[6px] mobile-custom-dots md:hidden left-1/2 -translate-x-1/2"></div>

          {/* Custom bullet styles */}
          <style jsx global>{`
          .custom-bullet {
            width: 10px;
            height: 10px;
            border-radius: 9999px;
            background-color: rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
            cursor: pointer;
          }
          .custom-bullet.swiper-pagination-bullet-active {
            background-color: white;
          }
        `}</style>

        </div>

        <section>
          <div>

            <div className="!py-[8px] overflow-hidden !bg-[#FFFFD0]">
              <style jsx>{`
              .scroll-banner {
                display: inline-flex;
                animation: scroll 50s linear infinite;
                white-space: nowrap;
              }
              .scroll-banner span {
                margin-right: 60px; /* Adjust spacing between text repetitions */
              }
              @keyframes scroll {
                from {
                  transform: translateX(0);
                }
                to {
                  transform: translateX(-100%);
                }
              }
            `}</style>

              <div className="scroll-banner">
                {/* Repeat the text enough times to ensure no gap */}
                {Array(10).fill(0).map((_, i) => (
                  <span
                    key={i}
                    className="!text-[#565609] !text-[30px] !font-semibold whitespace-nowrap"
                  >
                    Buy 2 Get 10% Off
                  </span>
                ))}
                {/* Duplicate the content for seamless looping */}
                {Array(10).fill(0).map((_, i) => (
                  <span
                    key={`duplicate-${i}`}
                    className="!text-[#565609] !text-[30px] !font-semibold whitespace-nowrap"
                  >
                    Buy 2 Get 10% Off
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>


        <div className="min-h-screen !bg-white">
          <div className="max-w-7xl mx-auto !px-4 !py-16 md:!py-20 ">
            {/* Title */}
            <h1 className="font-arbutus !text-[32px] leading-[32px] !text-[#202020] text-center !mb-[14px]">
              Shop by Collection
            </h1>

            {/* Collection Grid */}
            <div className="!grid !grid-cols-2 sm:!grid-cols-3 lg:!grid-cols-4 !gap-6">
              {collections.map((collection) => (
                <div
                  key={collection.id}
                  className="group !cursor-pointer"
                >
                  <div className="!relative !w-full !aspect-[382/477] !rounded-xl !overflow-hidden !bg-[#EBEBEB]">
                    <img
                      src={collection.image}
                      alt={collection.title}
                      className="!w-full !h-full !object-cover !transition-transform !duration-300 group-hover:!scale-105"
                    />
                    <div className="!absolute !inset-0 !bg-black/5 group-hover:!bg-black/20 !transition-all !duration-300" />
                    <div className="!absolute !bottom-6 !left-0 !right-0 !px-6">
                      <h3 className="!font-arbutus !text-white !text-lg !text-center">
                        {collection.title}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <section className="py-16">
          <div className="max-w-6xl mx-auto !bg-[#FCFCDD] !py-[10px] md:!px-[0px] !px-[10px] !rounded-[2px]">
            <div className="grid !grid-cols-1 md:!grid-cols-4 gap-8  text-center !border-t !border-b  md:!border-l-none !border-l md:!border-r-none !border-r !border-[#E2F4B8]">
              <div className="flex flex-col items-center gap-6 md:!border-r !border-l-none !border-r-none md:!py-16 !py-8 !border-[#E2F4B8]">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61" fill="none">
                  <path d="M56.1564 29.0281C56.1564 25.4938 54.0096 22.4938 50.9815 21.3125C51.0377 20.8813 51.0846 20.4406 51.0846 19.9906C51.0846 14.7313 46.9502 10.4656 41.8502 10.4656C40.8002 10.4656 39.7877 10.6531 38.8502 10.9906C37.6971 7.09063 34.1814 4.25 30.0189 4.25C25.8564 4.25 22.3502 7.08125 21.1971 10.9719C20.2689 10.6531 19.2846 10.4656 18.2533 10.4656C13.1533 10.4656 9.01895 14.7313 9.01895 19.9906C9.01895 20.4219 9.05645 20.8438 9.1127 21.2656C6.02832 22.4188 3.8252 25.4563 3.8252 29.0281C3.8252 32.6 6.02832 35.6375 9.1127 36.7906C9.05645 37.2125 9.01895 37.6344 9.01895 38.0656C9.01895 42.1625 11.5314 45.6406 15.0377 46.9813C15.4221 46.8406 15.7877 46.7 16.1158 46.55C10.8564 41.1313 11.3252 34.5781 11.3533 34.2688C11.4189 33.4906 11.9533 32.8344 12.7127 32.6187C12.8814 32.5719 13.0596 32.5438 13.2283 32.5438C13.8096 32.5438 14.3721 32.8156 14.7377 33.3031C15.6564 34.5406 18.3564 35.4219 19.9221 35.7125C21.0096 35.7594 26.8596 36.1813 30.1408 40.0531C31.8096 38.3563 34.8002 36.4062 40.0314 35.7219C41.5127 35.4688 44.3252 34.5781 45.2627 33.3031C45.6189 32.8156 46.1814 32.5438 46.7721 32.5438C46.9408 32.5438 47.1189 32.5625 47.2877 32.6187C48.0377 32.8344 48.5814 33.4906 48.6471 34.2688C48.6752 34.5781 49.144 41.1313 43.8846 46.55C44.2221 46.7 44.6064 46.85 45.0096 47C48.5533 45.6688 51.0939 42.1719 51.0939 38.0563C51.0939 37.6063 51.0471 37.175 50.9908 36.7438C54.0096 35.5625 56.1658 32.5531 56.1658 29.0188L56.1564 29.0281Z" fill="url(#paint0_linear_2_2266)" />
                  <path d="M40.6214 46.9344C47.3808 41.8437 46.7714 34.4375 46.7714 34.4375C45.0183 36.8094 40.2745 37.5969 40.2745 37.5969C31.5839 38.7406 29.9995 43.5125 29.9995 43.5125C27.9183 37.7375 19.7245 37.5969 19.7245 37.5969C19.7245 37.5969 14.9808 36.8094 13.2277 34.4375C13.2277 34.4375 12.6089 41.8437 19.3777 46.9344C19.3777 46.9344 16.8933 48.6875 13.2183 49.4844C13.2183 49.4844 16.3308 52.625 25.2745 51.4813C25.6589 51.4344 26.062 51.4531 26.437 51.5938C27.0745 51.8281 27.9183 52.3344 27.862 53.4406V56.7594H32.1558V53.4406C32.1089 52.4188 32.8308 51.8938 33.4495 51.65C33.862 51.4813 34.312 51.4344 34.7527 51.4906C43.687 52.625 46.7995 49.4937 46.7995 49.4937C43.1245 48.7062 40.6402 46.9438 40.6402 46.9438L40.6214 46.9344Z" fill="url(#paint1_linear_2_2266)" />
                  <defs>
                    <linearGradient id="paint0_linear_2_2266" x1="29.9955" y1="4.25" x2="29.9955" y2="47" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#E3F3AD" />
                      <stop offset="1" stop-color="#80C837" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_2_2266" x1="30.0062" y1="34.4375" x2="30.0062" y2="56.7594" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#E3F3AD" />
                      <stop offset="1" stop-color="#80C837" />
                    </linearGradient>
                  </defs>
                </svg>
                <span className="!text-[#585834] !text-[14px] !font-semibold">Pure Cotton Fabric</span>
              </div>
              <div className="flex flex-col items-center gap-6 md:!border-r !border-r-none md:!py-16 !py-8 !border-[#E2F4B8]">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61" fill="none">
                  <g clip-path="url(#clip0_2_2271)">
                    <path d="M30.3079 45.9672C25.8471 44.8113 20.1691 41.4059 15.2354 35.4326C23.3032 41.5219 27.9141 44.5503 38.2006 45.2557C33.3246 44.2142 27.118 41.4717 24.2388 34.4744C21.7259 28.3623 20.5884 23.328 19.3957 19.472C19.0193 21.2117 18.0077 22.8929 15.8441 24.167C15.8441 24.167 16.8108 23.328 17.5366 21.4215C18.5464 18.7696 18.0734 15.7815 16.2967 13.5707C14.5176 11.359 11.7002 10.2525 8.89298 10.6721C8.89114 10.6731 8.88682 10.6731 8.88264 10.6742C-0.729335 12.1198 -5.06031 30.1103 9.0311 43.601C17.6744 51.6082 28.6216 51.1332 36.1566 49.2833C45.0737 50.2817 53.925 47.1271 60 38.8309C57.8941 40.6202 47.4757 50.4155 30.3079 45.9672Z" fill="url(#paint0_linear_2_2271)" />
                  </g>
                  <defs>
                    <linearGradient id="paint0_linear_2_2271" x1="30" y1="10.5845" x2="30" y2="50.4157" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#E3F3AD" />
                      <stop offset="1" stop-color="#80C837" />
                    </linearGradient>
                    <clipPath id="clip0_2_2271">
                      <rect width="60" height="60" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
                <span className="!text-[#585834] !text-[14px] !font-semibold">Smooth Comfort Fit</span>
              </div>
              <div className="flex flex-col items-center gap-6 md:!border-r !border-r-none md:!py-16 !py-8 !border-[#E2F4B8]">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61" fill="none">
                  <path d="M56.8008 26.75C55.793 25.7422 54.4688 25.1914 53.0508 25.1914C47.6836 25.1914 42.3867 26.0586 37.3008 27.7812L34.9336 28.5781C34.793 28.625 34.7109 28.4258 34.8398 28.3672L37.0898 27.2539C41.9062 24.875 46.2656 21.7461 50.0625 17.9492C51.0586 16.9531 51.6094 15.6523 51.6211 14.2695C51.6562 11.3633 49.2891 8.9375 46.3828 8.89062C44.9414 8.86719 43.582 9.42969 42.5625 10.4492C38.7656 14.2461 35.6367 18.6055 33.2578 23.4219L32.1445 25.6719C32.0742 25.8008 31.8867 25.7188 31.9336 25.5781L32.7305 23.2109C34.4531 18.125 35.3203 12.8281 35.3203 7.46094C35.3203 6.04297 34.7695 4.70703 33.7617 3.71094C32.7539 2.70312 31.4297 2.15234 30.0117 2.15234C28.5938 2.15234 27.2578 2.70312 26.2617 3.71094C25.2539 4.71875 24.7031 6.04297 24.7031 7.46094C24.7031 12.8281 25.5703 18.125 27.293 23.2109L28.0898 25.5781C28.1367 25.7188 27.9375 25.8008 27.8789 25.6719L26.7656 23.4219C24.3867 18.6055 21.2578 14.2461 17.4609 10.4492C16.4648 9.45313 15.1641 8.90234 13.7812 8.89062C10.8633 8.85547 8.4375 11.2227 8.40234 14.1289C8.37891 15.5703 8.94141 16.9297 9.96094 17.9492C13.7578 21.7461 18.1172 24.875 22.9336 27.2539L25.1836 28.3672C25.3125 28.4375 25.2305 28.625 25.0898 28.5781L22.7227 27.7812C17.6367 26.0586 12.3398 25.1914 6.97266 25.1914C5.55469 25.1914 4.21875 25.7422 3.22266 26.75C1.14844 28.8242 1.14844 32.1875 3.22266 34.2617C4.23047 35.2695 5.55469 35.8203 6.97266 35.8203C12.3398 35.8203 17.6367 34.9531 22.7227 33.2305L25.0898 32.4336C25.2305 32.3867 25.3125 32.5859 25.1836 32.6445L22.9336 33.7578C18.1172 36.1367 13.7578 39.2656 9.96094 43.0625C8.96484 44.0586 8.41406 45.3594 8.40234 46.7422C8.36719 49.6484 10.7344 52.0742 13.6406 52.1211C15.082 52.1445 16.4414 51.582 17.4609 50.5625C21.2578 46.7656 24.3867 42.4062 26.7656 37.5898L27.8789 35.3398C27.9492 35.2109 28.1367 35.293 28.0898 35.4336L27.293 37.8008C25.5703 42.8867 24.7031 48.1836 24.7031 53.5508C24.7031 54.9688 25.2539 56.3047 26.2617 57.3008C27.2695 58.3086 28.5938 58.8594 30.0117 58.8594C31.4297 58.8594 32.7656 58.3086 33.7617 57.3008C34.7695 56.293 35.3203 54.9688 35.3203 53.5508C35.3203 48.1836 34.4531 42.8867 32.7305 37.8008L31.9336 35.4336C31.8867 35.293 32.0859 35.2109 32.1445 35.3398L33.2578 37.5898C35.6367 42.4062 38.7656 46.7656 42.5625 50.5625C43.5586 51.5586 44.8594 52.1094 46.2422 52.1211C49.1484 52.1562 51.5742 49.7891 51.6211 46.8828C51.6445 45.4414 51.082 44.082 50.0625 43.0625C46.2656 39.2656 41.9062 36.1367 37.0898 33.7578L34.8398 32.6445C34.7109 32.5742 34.793 32.3867 34.9336 32.4336L37.3008 33.2305C42.3867 34.9531 47.6836 35.8203 53.0508 35.8203C54.4688 35.8203 55.8047 35.2695 56.8008 34.2617C58.875 32.1875 58.875 28.8125 56.8008 26.75Z" fill="url(#paint0_linear_2_2275)" />
                  <defs>
                    <linearGradient id="paint0_linear_2_2275" x1="30.0117" y1="2.15234" x2="30.0117" y2="58.8594" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#E3F3AD" />
                      <stop offset="1" stop-color="#80C837" />
                    </linearGradient>
                  </defs>
                </svg>
                <span className="!text-[#585834] !text-[14px] !font-semibold">Exclusive Designs</span>
              </div>
              <div className="flex flex-col items-center gap-6 md:!py-16 !py-8 ">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61" fill="none">
                  <path d="M47.6634 33.7223C32.0707 36.2865 29.2986 39.5436 27.2196 58.5321C27.1503 59.1558 26.2494 59.1558 26.1801 58.5321C24.1011 39.5436 21.329 36.3558 5.73634 33.7223C5.11263 33.653 5.11263 32.7521 5.73634 32.6828C21.329 30.1187 24.1011 26.9308 26.1801 7.94239C26.2494 7.31868 27.1503 7.31868 27.2196 7.94239C29.2986 26.9308 32.0707 30.0494 47.6634 32.6828C48.2178 32.7521 48.2178 33.5837 47.6634 33.7223Z" fill="url(#paint0_linear_2_2280)" />
                  <path d="M54.3154 11.8234C49.4643 12.7936 48.0783 14.3875 47.2467 20.0702C47.1774 20.6939 46.2765 20.6939 46.2072 20.0702C45.3755 14.3875 43.9895 12.7936 39.1385 11.7541C38.5841 11.6155 38.5841 10.8532 39.1385 10.7146C43.9202 9.74438 45.3755 8.15045 46.2072 2.46778C46.2765 1.84407 47.1774 1.84407 47.2467 2.46778C48.0783 8.15045 49.4643 9.74438 54.3154 10.7839C54.8698 10.9225 54.8698 11.7541 54.3154 11.8234Z" fill="url(#paint1_linear_2_2280)" />
                  <defs>
                    <linearGradient id="paint0_linear_2_2280" x1="26.6739" y1="7.47461" x2="26.6739" y2="58.9998" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#E3F3AD" />
                      <stop offset="1" stop-color="#80C837" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_2_2280" x1="46.7269" y1="2" x2="46.7269" y2="20.538" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#E3F3AD" />
                      <stop offset="1" stop-color="#80C837" />
                    </linearGradient>
                  </defs>
                </svg>
                <span className="!text-[#585834] !text-[14px] !font-semibold">Limited Edition</span>
              </div>
            </div>
          </div>
        </section>

        <section className="section-padding bg-white">
          <div className="max-w-7xl mx-auto !px-[16px]">
            <div className="!text-center !mb-8">
              <h2 className="!text-3xl !font-arbutus !mb-6">
                {/* {featuredcategoriesListData?.[0]?.name || 'Exclusives Only'} */}
                Exclusives Only
              </h2>
              <div className="!flex !justify-center !gap-2 !mb-12">
                {sizes.map((size) => (
                  <button
                    key={size}
                    onClick={() => setSelectedSize(size)}
                    className={`!w-[60px] !h-[40px] !rounded-[2px] font-arbutus !transition-colors ${selectedSize === size
                      ? "!bg-[#202020] !text-white"
                      : "!bg-[#ECEEE9] !text-primary hover:!bg-[#c3c3c3]"
                      }`}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>

            <div className="relative">
              <Swiper
                modules={[Navigation, Autoplay]}
                loop={true}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                navigation={{
                  nextEl: ".custom-prev",
                  prevEl: ".custom-next",
                }}
                spaceBetween={24}
                slidesPerView={2}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                }}
                className=""
              >
                {featuredcategoriesListData[0]?.products?.map((product: any) => {
                  // Handle image URLs safely
                  const images = product.imageurl
                    ? product.imageurl
                      .split(',')
                      .map(
                        (url: any) =>
                          `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/${url.trim()}`
                      )
                    : [];

                  // Calculate savings
                  const savings = Math.round(
                    ((parseFloat(product?.mrp || 1) - parseFloat(product?.sp || 0)) /
                      parseFloat(product?.mrp || 1)) *
                    100
                  );

                  return (
                    <SwiperSlide key={product.id}>
                      <div className="group !cursor-pointer">
                        <div className="!relative bg-muted !rounded !aspect-[382/477] !overflow-hidden !mb-[14px]">
                          <Link href={`/p/${product.seo_url}`}>
                            <img
                              src={
                                images[0] ||
                                'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/vilvabusiness/no-image.webp'
                              }
                              alt={product.name || 'Product'}
                              className="!w-full !h-full !object-cover group-hover:!scale-105 !transition-transform !duration-300"
                            />
                            <span className="!absolute !top-3 !left-3 !bg-white !px-2 !py-1 !text-xs font-arbutus">
                              Buy 3 @ ₹{product?.sp || 0}
                            </span>
                          </Link>
                        </div>
                        <div>
                          <div className="!flex !items-center !justify-between">
                            <h3 className="!font-arbutus !text-[#202020] truncate">
                              {/* {product.name?.length > (isMobile ? 22 : 40)
                        ? product.name.slice(0, isMobile ? 22 : 40) + '...'
                        : product.name || 'Unnamed Product'} */}
                              {product.name || 'Unnamed Product'}
                            </h3>
                            <svg
                              className="cursor-pointer"
                              onClick={async () =>
                                addtowishlist(
                                  product,
                                  productwishlistData,
                                  setproductwishlistData,
                                  navigate
                                )
                              }
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill={
                                productwishlistData?.includes(product?.id?.toString())
                                  ? "#f45440"
                                  : "none"
                              }
                            >
                              <path
                                d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                                stroke="#676767"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <Link href={`/p/${product.seo_url}`}>
                            <div className="!flex !items-center md:!space-x-[12px] !space-x-[4px]">
                              <p className="!text-sm !font-arbutus !text-[#202020] !line-through whitespace-nowrap">
                                ₹ {product?.mrp || 1}
                              </p>
                              <p className="text-sm font-arbutus !text-[#202020] whitespace-nowrap">
                                ₹ {product?.sp || 0}
                              </p>
                              <p className="text-sm font-arbutus !text-[#409A19] whitespace-nowrap">
                                Save {savings}%
                              </p>
                            </div>
                          </Link>
                          <p className="text-xs font-arbutus !text-[#E82020]">
                            {product.stock || 'In Stock'}
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>

              {/* Custom Nav Buttons with SVG */}
              <button className="custom-prev absolute top-[40%] !left-2 !z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="!w-8 !h-8 !text-black !bg-white !rounded-full !shadow !p-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button className="custom-next absolute top-[40%] !right-2 !z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="!w-8 !h-8 !text-black !bg-white !rounded-full !shadow !p-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </section>


        <section className="section-padding bg-white md:!py-[100px] !py-[30px]">
          <div className="max-w-7xl mx-auto !px-[16px]">
            <div className="!flex !justify-between !items-center !mb-[10px]">
              <h2 className="!text-[20px] font-arbutus !font-semibold">
                {featuredcategoriesListData?.[0]?.name || 'New Arrival'}
              </h2>
              <button className="!bg-black !text-white !text-[14px] !rounded-tl-[32px] !rounded-br-[32px] !px-[24px] !py-2 !rounded-sm !font-arbutus hover:!bg-black/90">
                <a href="/products/new-arrivals">View All</a>
              </button>
            </div>
            <div className="relative">
              <Swiper
                modules={[Navigation, Autoplay]}
                loop={true}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                navigation={{
                  nextEl: ".custom-next",
                  prevEl: ".custom-prev",
                }}
                spaceBetween={24}
                slidesPerView={2}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                }}
                className=""
              >
                {featuredcategoriesListData[0]?.products?.map((product: any) => {
                  // Handle image URLs safely
                  const images = product.imageurl
                    ? product.imageurl
                      .split(',')
                      .map(
                        (url: any) =>
                          `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/${url.trim()}`
                      )
                    : [];

                  // Calculate savings
                  const savings = Math.round(
                    ((parseFloat(product?.mrp || 1) - parseFloat(product?.sp || 0)) /
                      parseFloat(product?.mrp || 1)) *
                    100
                  );

                  return (
                    <SwiperSlide key={product.id}>
                      <div className="group !cursor-pointer">
                        <div className="!relative bg-muted !rounded !aspect-[382/477] !overflow-hidden !mb-[14px]">
                          <Link href={`/p/${product.seo_url}`}>
                            <img
                              src={
                                images[0] ||
                                'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/vilvabusiness/no-image.webp'
                              }
                              alt={product.name || 'Product'}
                              className="!w-full !h-full !object-cover group-hover:!scale-105 !transition-transform !duration-300"
                            />
                          </Link>
                          <span className="!absolute !top-3 !left-3 !bg-white !px-2 !py-1 !text-xs font-arbutus">
                            Buy 3 @ ₹{product?.sp || 0}
                          </span>
                        </div>
                        <div>
                          <div className="!flex !items-center !justify-between">
                            <h3 className="!font-arbutus !text-[#202020] truncate">
                              {/* {product.name?.length > (isMobile ? 22 : 40)
                                ? product.name.slice(0, isMobile ? 22 : 40) + '...'
                                : product.name || 'Unnamed Product'} */}
                              {product.name || 'Unnamed Product'}
                            </h3>
                            <svg
                              className="cursor-pointer"
                              onClick={async () =>
                                addtowishlist(
                                  product,
                                  productwishlistData,
                                  setproductwishlistData,
                                  navigate
                                )
                              }
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill={
                                productwishlistData?.includes(product?.id?.toString())
                                  ? "#f45440"
                                  : "none"
                              }
                            >
                              <path
                                d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                                stroke="#676767"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <Link href={`/p/${product.seo_url}`}>
                            <div className="!flex !items-center md:!space-x-[12px] !space-x-[4px]">
                              <p className="!text-sm !font-arbutus !text-[#202020] !line-through whitespace-nowrap">
                                ₹ {product?.mrp || 1}
                              </p>
                              <p className="text-sm font-arbutus !text-[#202020] whitespace-nowrap">
                                ₹ {product?.sp || 0}
                              </p>
                              <p className="text-sm font-arbutus !text-[#409A19] whitespace-nowrap">
                                Save {savings}%
                              </p>
                            </div>
                          </Link>
                          <p className="text-xs font-arbutus !text-[#E82020]">
                            {product.stock || 'In Stock'}
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>

              {/* Custom Nav Buttons with SVG */}
              <button className="custom-prev absolute top-[40%] !left-2 !z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="!w-8 !h-8 !text-black !bg-white !rounded-full !shadow !p-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button className="custom-next absolute top-[40%] !right-2 !z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="!w-8 !h-8 !text-black !bg-white !rounded-full !shadow !p-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </section>


        <section className="lg:!py-20 !py-14 !px-[16px]">
          <div className="max-w-5xl mx-auto !bg-[#FFFFE7]  ">
            <div className="!flex !flex-col md:!flex-row ">
              <div className="!relative !w-full">
                <img
                  src="https://api.builder.io/api/v1/image/assets/TEMP/d2dd6f8e2f0a643eae5897b297372ad9b700815c?width=1200"
                  alt="Cotton promise"
                  className="!w-full md:!h-[550px] !h-[500px] !object-cover !rounded"
                />
                <div className="!absolute !inset-0 !left-0 !right-0  !w-full">
                  <span className="!text-white !px-4 !py-2 !font-anonymous !text-center !font-bold !text-sm !tracking-wider !uppercase">
                    Every glow tells a story
                  </span>
                </div>
                <div className="!absolute !bottom-[10px] !right-[10px] !flex !gap-3">
                  <button className="!w-12 !h-15 !bg-white/20 !backdrop-blur !border !border-white !rounded-full !flex !items-center !justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                      <path d="M12.7808 29.46L14.7885 30.1801L14.5575 30.8239L13.3504 30.3909L13.1727 30.8865L14.3079 31.2937L14.0769 31.9375L12.9417 31.5303L12.5575 32.6021L11.7568 32.3149L12.7808 29.46Z" fill="white" />
                      <path d="M15.3887 30.373C15.7467 30.365 16.1048 30.3825 16.4604 30.4254C16.8377 30.4342 17.2032 30.559 17.5071 30.7829C17.6013 30.8704 17.6724 30.9798 17.7141 31.1014C17.7557 31.223 17.7666 31.353 17.7458 31.4798C17.7221 31.6401 17.6503 31.7894 17.54 31.908C17.4296 32.0266 17.2859 32.1089 17.1278 32.1441L17.1259 32.162C17.2203 32.2282 17.2994 32.314 17.3577 32.4135C17.4161 32.5131 17.4523 32.624 17.464 32.7387C17.5321 33.0589 17.5854 33.5131 17.6304 33.6359L16.7718 33.5395C16.6956 33.3072 16.6436 33.0677 16.6167 32.8247C16.5634 32.452 16.4508 32.3669 16.169 32.3353L16.0168 32.3182L15.891 33.4406L15.0547 33.3467L15.3887 30.373ZM16.0838 31.7235L16.334 31.7515C16.665 31.7887 16.8768 31.6766 16.9026 31.4485C16.9281 31.2206 16.7713 31.0852 16.4851 31.053C16.3778 31.0375 16.2694 31.0314 16.161 31.0348L16.0838 31.7235Z" fill="white" />
                      <path d="M20.7344 32.1549L19.5102 32.3008L19.5715 32.8145L20.9384 32.6517L21.0192 33.3308L18.8079 33.5941L18.4492 30.5831L20.5938 30.3276L20.6745 31.0067L19.3745 31.1615L19.4292 31.6217L20.6534 31.4758L20.7344 32.1549Z" fill="white" />
                      <path d="M23.8026 31.198L22.6418 31.6131L22.816 32.1002L24.1121 31.6366L24.3425 32.2805L22.2458 33.0303L21.2246 30.1754L23.2579 29.4482L23.4881 30.0922L22.2557 30.533L22.4117 30.9693L23.5721 30.5542L23.8026 31.198Z" fill="white" />
                      <path d="M8.44707 9.62613C8.37277 9.91147 8.24263 10.1792 8.0642 10.414C7.35311 11.4158 6.45911 11.4544 5.79497 10.9829C4.93639 10.3733 4.95342 9.37001 5.52911 8.55908C5.69139 8.30988 5.90544 8.09854 6.1567 7.93945L6.59067 8.46295C6.40002 8.58536 6.23507 8.74378 6.10506 8.92932C5.81062 9.34392 5.77409 9.86975 6.26573 10.2189C6.69145 10.5211 7.19435 10.4422 7.55635 9.93211C7.68284 9.75723 7.77852 9.56203 7.83925 9.35492L8.44707 9.62613Z" fill="white" />
                      <path d="M7.59705 6.38907L8.30237 7.23639L9.18099 6.50497L8.47567 5.65752L9.12937 5.11328L11.0701 7.44472L10.4164 7.98895L9.64764 7.06541L8.76902 7.79683L9.53779 8.72037L8.8841 9.2646L6.94336 6.9333L7.59705 6.38907Z" fill="white" />
                      <path d="M13.01 5.14428L11.8976 5.67574L12.1206 6.14266L13.3629 5.54912L13.6579 6.16614L11.6482 7.12636L10.3408 4.39008L12.2895 3.45898L12.5842 4.076L11.4029 4.64056L11.6026 5.05873L12.7153 4.52712L13.01 5.14428Z" fill="white" />
                      <path d="M16.6952 4.35088C16.6238 3.97954 16.5505 3.56769 16.4637 3.04845L16.4502 3.05064C16.4151 3.49449 16.3516 3.98861 16.2994 4.38507L16.1566 5.52202L15.4867 5.63422L15.0399 4.60041C14.8896 4.24692 14.7141 3.7973 14.5598 3.36691L14.551 3.36842C14.6098 3.82848 14.6759 4.30555 14.7248 4.68045L14.8668 5.80175L14.0769 5.93386L13.7451 2.91483L14.9434 2.71433L15.2692 3.4353C15.4071 3.74072 15.5691 4.13774 15.699 4.50386L15.7166 4.50084C15.7512 4.10739 15.7877 3.645 15.8314 3.33217L15.9418 2.54733L17.1089 2.35205L17.7469 5.31987L16.9125 5.4594L16.6952 4.35088Z" fill="white" />
                      <path d="M19.4349 2.48149L19.241 5.50713L18.3926 5.45274L18.5865 2.42725L19.4349 2.48149Z" fill="white" />
                      <path d="M22.4547 6.09911C22.1615 6.13099 21.8649 6.10443 21.5821 6.02097C20.3928 5.7117 20.0393 4.8895 20.2442 4.10111C20.5096 3.08186 21.4538 2.74141 22.4162 2.9919C22.7069 3.05512 22.9805 3.18018 23.2185 3.35857L22.8832 3.95046C22.7011 3.81541 22.4943 3.71738 22.2745 3.66193C21.7823 3.5338 21.2778 3.68624 21.1259 4.27003C20.9946 4.77526 21.2467 5.2176 21.8524 5.37511C22.0608 5.43112 22.2773 5.45123 22.4926 5.43457L22.4547 6.09911Z" fill="white" />
                      <path d="M24.1126 6.19149L23.5797 6.73778L22.8008 6.2953L25.1329 4.13086L26.1426 4.70448L25.5328 7.84698L24.7108 7.3802L24.8797 6.62709L24.1126 6.19149ZM25.073 6.02258L25.1966 5.47683C25.2342 5.30146 25.2884 5.07844 25.3282 4.89922L25.3202 4.89469C25.1906 5.02296 25.0425 5.19242 24.9126 5.32069L24.5251 5.71139L25.073 6.02258Z" fill="white" />
                      <path d="M27.9888 6.00391L28.606 6.58879L27.0094 8.27396L27.9597 9.17443L27.4711 9.69037L25.9033 8.20515L27.9888 6.00391Z" fill="white" />
                      <path d="M28.5655 9.71062C28.6064 10.0108 28.7127 10.2984 28.877 10.553C29.0352 10.7881 29.1901 10.8575 29.317 10.772C29.4254 10.6993 29.4186 10.5358 29.2986 10.1719C29.1291 9.66228 29.111 9.15938 29.5479 8.86563C30.0033 8.55939 30.6155 8.7441 31.055 9.39751C31.2393 9.65617 31.3671 9.95071 31.4302 10.262L30.7696 10.4731C30.7227 10.2204 30.6253 9.97972 30.4834 9.76541C30.3431 9.55626 30.1953 9.4821 30.0871 9.55489C29.9528 9.64525 30.016 9.83586 30.1324 10.2348C30.3044 10.8293 30.2247 11.2189 29.844 11.475C29.4222 11.7587 28.8102 11.6875 28.2705 10.8848C28.0802 10.6038 27.9514 10.2858 27.8926 9.95163L28.5655 9.71062Z" fill="white" />
                      <path d="M19.7439 16.1847V11.0347H16.2561V16.1855C16.2552 16.3152 16.2172 16.442 16.1467 16.5509C16.0761 16.6599 15.9759 16.7463 15.8579 16.8002C14.8156 17.2875 13.9706 18.1157 13.4624 19.148C12.9542 20.1803 12.8132 21.355 13.0627 22.4782C13.3121 23.6014 13.9371 24.606 14.8344 25.3262C15.7317 26.0463 16.8478 26.439 17.9984 26.4394C19.149 26.4397 20.2653 26.0478 21.1631 25.3282C22.0609 24.6086 22.6865 23.6044 22.9366 22.4813C23.1868 21.3582 23.0465 20.1834 22.539 19.1508C22.0314 18.1182 21.187 17.2895 20.145 16.8016C20.0263 16.7476 19.9255 16.6609 19.8545 16.5517C19.7834 16.4424 19.745 16.3151 19.7439 16.1847Z" stroke="white" stroke-width="0.84375" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M19.8763 9.5625H16.1247C15.7182 9.5625 15.3887 9.89203 15.3887 10.2985V10.2988C15.3887 10.7053 15.7182 11.0348 16.1247 11.0348H19.8763C20.2828 11.0348 20.6123 10.7053 20.6123 10.2988V10.2985C20.6123 9.89203 20.2828 9.5625 19.8763 9.5625Z" stroke="white" stroke-width="0.84375" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M13.1768 19.8564H22.8221C23.0613 20.6139 23.1187 21.417 22.9897 22.2007C22.8606 22.9845 22.5488 23.7268 22.0794 24.3675C21.61 25.0083 20.9963 25.5295 20.2879 25.8888C19.5796 26.2482 18.7966 26.4356 18.0023 26.436C17.208 26.4363 16.4248 26.2495 15.7161 25.8908C15.0075 25.532 14.3933 25.0114 13.9234 24.371C13.4534 23.7307 13.1409 22.9886 13.0112 22.205C12.8815 21.4213 12.9382 20.6182 13.1768 19.8606" stroke="white" stroke-width="0.84375" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M17.9995 24.6846C18.4124 24.6846 18.7471 24.3499 18.7471 23.937C18.7471 23.5241 18.4124 23.1895 17.9995 23.1895C17.5866 23.1895 17.252 23.5241 17.252 23.937C17.252 24.3499 17.5866 24.6846 17.9995 24.6846Z" stroke="white" stroke-width="0.84375" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M19.8843 22.6455C20.2971 22.6455 20.6318 22.3108 20.6318 21.898C20.6318 21.4851 20.2971 21.1504 19.8843 21.1504C19.4714 21.1504 19.1367 21.4851 19.1367 21.898C19.1367 22.3108 19.4714 22.6455 19.8843 22.6455Z" stroke="white" stroke-width="0.84375" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M16.1157 22.6455C16.5286 22.6455 16.8633 22.3108 16.8633 21.898C16.8633 21.4851 16.5286 21.1504 16.1157 21.1504C15.7029 21.1504 15.3682 21.4851 15.3682 21.898C15.3682 22.3108 15.7029 22.6455 16.1157 22.6455Z" stroke="white" stroke-width="0.84375" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M26.3086 29.3437C28.8633 27.473 30.7119 24.7948 31.555 21.7427C32.3982 18.6906 32.1865 15.4432 30.9543 12.5264" stroke="white" stroke-width="0.84375" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M5.04589 12.5264C3.8137 15.4432 3.60203 18.6906 4.44516 21.7427C5.28829 24.7948 7.13686 27.473 9.6916 29.3437" stroke="white" stroke-width="0.84375" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                  <button className="!w-12 h-15 !bg-white/20 !backdrop-blur !border !border-white !rounded-full !flex !items-center !justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                      <path d="M9.62268 12.5255L9.62105 12.5249L9.61801 12.5235C9.61033 12.5201 9.60237 12.5187 9.59461 12.5158L9.592 12.5148C9.57876 12.5095 9.56526 12.5048 9.55154 12.5009C9.54716 12.4997 9.54285 12.4981 9.53846 12.4971C9.52986 12.4951 9.52123 12.495 9.51261 12.4936L9.50984 12.4933C9.49678 12.4913 9.48389 12.4889 9.47075 12.4881C9.46589 12.4878 9.4611 12.4869 9.45626 12.4868C9.44776 12.4866 9.43949 12.4881 9.43103 12.4884L9.42866 12.4886C9.41542 12.4891 9.40229 12.4894 9.38916 12.4911C9.38442 12.4918 9.37965 12.4919 9.37493 12.4927C9.36674 12.4941 9.35901 12.4971 9.35095 12.499C9.33694 12.5019 9.3231 12.5056 9.30947 12.5099C9.3053 12.5113 9.30103 12.5123 9.29692 12.5139C9.28951 12.5167 9.28275 12.5209 9.2755 12.5241C9.26184 12.5298 9.24848 12.5362 9.2355 12.5433C9.23183 12.5454 9.228 12.5471 9.2244 12.5494C9.2168 12.554 9.21022 12.5602 9.20292 12.5653C9.19138 12.573 9.18025 12.5813 9.16955 12.5902C9.16632 12.593 9.16284 12.5953 9.15971 12.5982C9.15127 12.606 9.14431 12.6154 9.13648 12.6239C9.13004 12.6309 9.12266 12.6366 9.11662 12.6441C9.11497 12.6462 9.11401 12.6485 9.11241 12.6506C9.10998 12.6538 9.10716 12.6565 9.10479 12.6597C9.09789 12.6692 9.09277 12.6802 9.0866 12.6903C9.07978 12.7015 9.07243 12.7124 9.06677 12.724C9.06553 12.7265 9.06371 12.7286 9.06251 12.7312L9.06111 12.7344L9.06045 12.7356L9.05989 12.7373C8.46136 14.0294 8.15294 15.4369 8.15628 16.8609C8.15628 17.0572 8.16371 17.2518 8.17512 17.4453L8.17469 17.4495C8.17469 17.46 8.17702 17.4699 8.17778 17.4803C8.33791 19.9774 9.44195 22.3202 11.2659 24.0332C13.0899 25.7463 15.4973 26.7013 17.9995 26.7047L18.0004 26.7047C20.5075 26.7014 22.9191 25.7428 24.7442 24.024C26.5693 22.3053 27.6707 19.9555 27.8243 17.4532C27.8244 17.4502 27.8252 17.4474 27.8252 17.4443L27.8251 17.4431C27.8364 17.2503 27.8438 17.0565 27.8438 16.8609C27.8478 15.3757 27.5122 13.9092 26.8627 12.5736L26.8617 12.571L26.8594 12.5672C26.8541 12.5567 26.8468 12.547 26.8405 12.5368C26.8322 12.5221 26.823 12.508 26.813 12.4945L26.8113 12.4919C26.8061 12.4854 26.7997 12.4806 26.7941 12.4744C26.7819 12.4603 26.7689 12.447 26.7549 12.4346C26.745 12.4262 26.7341 12.4197 26.7236 12.4123C26.7175 12.408 26.7116 12.4032 26.7052 12.3992C26.7014 12.3969 26.6982 12.3937 26.6943 12.3914L26.6884 12.3886C26.6751 12.3817 26.6615 12.3755 26.6476 12.3701C26.6384 12.3661 26.6298 12.361 26.6204 12.3577L26.6145 12.3562C26.6001 12.3519 26.5856 12.3484 26.5709 12.3457C26.5611 12.3436 26.5517 12.3401 26.5418 12.3387L26.5353 12.3383C26.5207 12.3369 26.506 12.3363 26.4912 12.3364L26.4906 12.3364C26.4805 12.3362 26.4706 12.3345 26.4605 12.3351L26.4539 12.3359C26.4387 12.3374 26.4235 12.3398 26.4085 12.3429C26.4021 12.3441 26.3957 12.3444 26.3893 12.3459C26.3858 12.3467 26.3822 12.3466 26.3787 12.3475L26.3732 12.3493C26.3567 12.3543 26.3406 12.3602 26.3249 12.3671C26.3158 12.3708 26.3065 12.3728 26.2976 12.3771C26.269 12.3909 23.4409 13.7713 22.5066 14.2393C20.447 15.2714 18.9263 16.7143 17.9971 18.4245C16.977 16.5589 15.3646 15.0863 13.4145 14.239C12.4947 13.814 9.74377 12.5798 9.62383 12.5261L9.62268 12.5255ZM9.61343 13.5927C10.858 14.6308 12.005 15.7806 13.0401 17.0277H9.00427C9.00325 16.972 9.00003 16.9168 9.00003 16.8609C8.99796 15.7427 9.20604 14.634 9.61343 13.5927ZM9.94879 20.8762C9.47707 19.9349 9.17558 18.9177 9.05825 17.8714H13.7064C14.4237 18.8205 15.0642 19.8252 15.6217 20.8762L9.94879 20.8762ZM10.4304 21.7199H16.0438C16.4451 22.5683 16.787 23.4436 17.0669 24.3393C17.1492 24.8465 17.2649 25.3477 17.4132 25.8397C16.0082 25.7469 14.6445 25.3259 13.4318 24.6104C12.2191 23.8948 11.1911 22.9049 10.4304 21.7199ZM18.5384 25.8434C18.8797 24.4238 19.3591 23.0409 19.9698 21.7147H25.573C24.8082 22.9081 23.7725 23.904 22.5501 24.6215C21.3277 25.3389 19.9532 25.7576 18.5384 25.8434ZM22.2197 17.8662H26.9425C26.8258 18.9123 26.5249 19.9296 26.0539 20.8709H20.3809C20.9179 19.8248 21.5326 18.8204 22.2197 17.8662ZM26.9959 17.0224H22.8539C23.8856 15.7123 25.0488 14.5114 26.3254 13.4385C26.7735 14.5237 27.0028 15.6868 27 16.8609C27 16.9151 26.9969 16.9685 26.9959 17.0224ZM22.8845 14.9935C23.1428 14.8642 23.5472 14.6645 23.997 14.4432C22.1011 16.3718 20.5352 18.599 19.3622 21.0358C19.3263 21.0818 19.3005 21.1348 19.2863 21.1913C18.7757 22.2761 18.3493 23.3986 18.0109 24.5489C17.9744 24.4215 17.9363 24.2954 17.8977 24.1697C17.2994 20.2984 19.1009 16.8896 22.8845 14.9935ZM17.5377 19.4114C17.2477 20.1565 17.0603 20.9376 16.9804 21.7332C15.722 18.9957 13.9624 16.5178 11.7924 14.4276C12.3039 14.6589 12.7729 14.8719 13.0607 15.0048C15.1733 15.9804 16.6774 17.4634 17.5377 19.4114Z" fill="white" />
                      <path d="M4.52148 25.4243L6.81297 24.0876L7.1879 24.7303L4.89641 26.0671L4.52148 25.4243Z" fill="white" />
                      <path d="M6.56854 28.3108L7.09808 28.9309L9.11682 27.2072L8.6694 26.6829L8.14206 27.133C7.86423 27.3628 7.60123 27.61 7.35461 27.873L7.34692 27.8636C7.52434 27.539 7.67792 27.202 7.80642 26.8551L8.10663 26.024L7.50046 25.314L5.48145 27.038L5.92914 27.562L6.47433 27.0965C6.77975 26.8358 7.07089 26.5821 7.3634 26.3063L7.37384 26.3181C7.20629 26.6627 7.05632 27.0155 6.9245 27.3753L6.56854 28.3108Z" fill="white" />
                      <path d="M10.4726 28.977C10.6835 29.1173 10.8625 29.3006 10.9977 29.5148L11.466 29.1338C11.3023 28.8843 11.0898 28.6703 10.8414 28.5049C10.074 27.9528 9.19978 27.9207 8.66364 28.6655C8.56115 28.8029 8.48843 28.9601 8.45013 29.1271C8.41182 29.2942 8.40877 29.4674 8.44117 29.6356C8.55491 30.0712 8.83459 30.4449 9.22038 30.6769C9.50722 30.876 9.82177 31.032 10.1539 31.1397L11.0004 29.963L10.0762 29.2984L9.74278 29.762L10.0754 30.0012L9.82463 30.3497C9.73872 30.3147 9.65797 30.2681 9.58458 30.2113C9.48893 30.1565 9.40589 30.0822 9.34085 29.9932C9.27581 29.9042 9.23022 29.8025 9.20706 29.6948C9.18391 29.587 9.18369 29.4756 9.20642 29.3677C9.22916 29.2599 9.27434 29.158 9.33903 29.0687C9.63567 28.6562 10.0954 28.7056 10.4726 28.977Z" fill="white" />
                      <path d="M13.8281 30.8942C13.8767 30.7927 13.8995 30.6807 13.8943 30.5683C13.8892 30.4558 13.8562 30.3464 13.7984 30.2498C13.5981 29.9871 13.3215 29.7926 13.0066 29.6928C12.7182 29.5695 12.4215 29.4669 12.1186 29.3857L11.1084 31.8027L11.7882 32.087L12.1694 31.1746L12.293 31.2262C12.5221 31.3221 12.5959 31.421 12.5493 31.7475C12.5124 31.9583 12.4973 32.1723 12.5042 32.3861L13.2021 32.6778C13.1944 32.5635 13.2612 32.1689 13.2823 31.8829C13.3007 31.7837 13.2976 31.6816 13.273 31.5837C13.2484 31.4857 13.2029 31.3943 13.1398 31.3155L13.1458 31.3007C13.2873 31.31 13.4283 31.2761 13.5502 31.2035C13.672 31.1309 13.7689 31.023 13.8281 30.8942ZM13.1271 30.6613C13.0497 30.8464 12.844 30.8887 12.5751 30.7761L12.3716 30.6912L12.6056 30.1314C12.6974 30.1552 12.787 30.1869 12.8733 30.2262C13.106 30.3234 13.2046 30.4756 13.1271 30.6613Z" fill="white" />
                      <path d="M16.4004 31.2735L16.5137 30.6857L14.6575 30.3276L14.1543 32.9337L16.0685 33.3033L16.1818 32.7154L14.9986 32.4871L15.0847 32.0424L16.1439 32.2469L16.2575 31.6591L15.198 31.4546L15.2751 31.0564L16.4004 31.2735Z" fill="white" />
                      <path d="M18.0278 30.7174C17.7158 30.7233 17.4046 30.7519 17.0967 30.8028L17.1703 33.4041C17.4321 33.4325 17.6957 33.4408 17.9588 33.4288C18.4447 33.4453 18.9233 33.3076 19.3261 33.0355C19.4852 32.9034 19.61 32.7347 19.6896 32.5438C19.7693 32.353 19.8014 32.1456 19.7834 31.9396C19.7871 31.7403 19.7376 31.5436 19.6399 31.3699C19.5422 31.1961 19.4 31.0515 19.2278 30.9511C18.86 30.7555 18.4421 30.6741 18.0278 30.7174ZM18.0725 32.8548C18.0148 32.8579 17.9568 32.8568 17.8992 32.8515L17.8553 31.3052C17.9407 31.2879 18.0275 31.2788 18.1146 31.278C18.5947 31.2645 18.9745 31.4744 18.9896 32.0017C19.0061 32.5801 18.6158 32.8471 18.0725 32.8548Z" fill="white" />
                      <path d="M20.2861 30.5229L21.0142 30.3688L21.5638 32.9654L20.8357 33.1195L20.2861 30.5229Z" fill="white" />
                      <path d="M23.4597 29.5483L21.6943 30.2259L22.6461 32.7045L24.4663 32.0059L24.2517 31.4468L23.1265 31.8791L22.9639 31.4561L23.9716 31.0691L23.7573 30.5099L22.7496 30.8967L22.6039 30.5181L23.6743 30.1072L23.4597 29.5483Z" fill="white" />
                      <path d="M25.9622 30.1332L26.848 30.6001L27.5275 30.1497L26.0611 27.937L25.4865 28.3177L25.8694 28.8956C26.0638 29.1991 26.2772 29.4901 26.5082 29.7668L26.4986 29.7734C26.1979 29.5579 25.8818 29.3646 25.553 29.1949L24.7644 28.7961L23.9863 29.3119L25.4527 31.5246L26.0273 31.1439L25.6313 30.5463C25.4093 30.2117 25.1929 29.892 24.9545 29.5679L24.9677 29.5591C25.2892 29.7673 25.6211 29.9589 25.9622 30.1332Z" fill="white" />
                      <path d="M29.3535 28.3965L27.8761 26.977L28.4057 26.426L27.968 26.0059L26.4043 27.6335L26.8419 28.0539L27.3603 27.5142L28.8377 28.9334L29.3535 28.3965Z" fill="white" />
                      <path d="M29.879 26.6181L30.3069 27.0746C30.5548 26.9108 30.7654 26.6966 30.9249 26.4459C31.3814 25.7326 31.2256 25.2165 30.8507 24.9764C30.5123 24.7595 30.1715 24.8314 29.754 25.1769C29.4741 25.4093 29.3431 25.5263 29.2236 25.45C29.1275 25.3884 29.1357 25.244 29.2547 25.0583C29.3773 24.8697 29.5367 24.7078 29.7232 24.582L29.3236 24.125C29.0956 24.2841 28.9035 24.4894 28.76 24.7276C28.3884 25.308 28.4532 25.8641 28.8578 26.1234C29.2462 26.3717 29.6436 26.1819 29.994 25.8685C30.2445 25.6452 30.3733 25.5829 30.4695 25.6444C30.5824 25.7166 30.5807 25.8652 30.4469 26.0742C30.2996 26.2948 30.1057 26.4804 29.879 26.6181Z" fill="white" />
                      <path d="M4.06477 11.6884L4.04199 12.5274L4.58818 12.6492L4.5983 12.0729L4.6014 12.0656L6.33896 12.8666L6.63737 12.2194L4.31368 11.1484L4.06477 11.6884Z" fill="white" />
                      <path d="M5.61181 8.94959C5.15588 9.57197 5.48271 10.1919 6.04467 10.6036C6.60992 11.0178 7.29629 11.1397 7.75002 10.5206C8.20815 9.89496 7.88461 9.27726 7.31936 8.86335C6.75713 8.45163 6.06774 8.32722 5.61181 8.94959ZM7.32265 10.1976C7.19933 10.3663 6.92028 10.3276 6.48193 10.0065C6.04384 9.68568 5.92602 9.43354 6.04687 9.26819C6.16772 9.10313 6.44375 9.13938 6.8821 9.46046C7.32018 9.78126 7.4413 10.0359 7.32265 10.1976Z" fill="white" />
                      <path d="M7.66359 6.66319C7.0934 7.18284 7.29088 7.8552 7.76027 8.37019C8.23241 8.88819 8.88088 9.1439 9.44833 8.62672C10.0215 8.10432 9.82681 7.43498 9.35468 6.91697C8.88528 6.40171 8.23406 6.14298 7.66359 6.66319ZM9.09347 8.22572C8.93938 8.36634 8.67324 8.27323 8.3074 7.87168C7.94128 7.47013 7.87563 7.19959 8.02697 7.06144C8.1783 6.92356 8.4417 7.01393 8.80782 7.41548C9.17367 7.81704 9.24178 8.09031 9.09347 8.22572Z" fill="white" />
                      <path d="M15.8759 3.53053L15.3266 2.83839L14.4043 2.98067L14.8091 5.6042L15.4903 5.49901L15.381 4.79067C15.3197 4.39351 15.2568 4.01284 15.1761 3.6187L15.1917 3.61623C15.3967 3.93989 15.6179 4.25294 15.8545 4.5542L16.4634 5.34878L17.2692 5.22464L16.8641 2.60107L16.183 2.70598L16.2887 3.39098C16.338 3.74821 16.4099 4.10196 16.5041 4.45006L16.4923 4.45171C16.3094 4.1301 16.1034 3.82223 15.8759 3.53053Z" fill="white" />
                      <path d="M19.4551 4.6926L19.5977 5.35233L20.4214 5.42072L19.751 2.70297L18.7388 2.61865L17.6836 5.19302L18.4642 5.25784L18.6864 4.6286L19.4551 4.6926ZM19.0011 3.64368C19.0572 3.49454 19.1124 3.30557 19.1681 3.15616L19.1761 3.15672C19.2104 3.31355 19.2494 3.51048 19.284 3.66319L19.3865 4.14165L18.8372 4.09605L19.0011 3.64368Z" fill="white" />
                      <path d="M21.8142 5.84017L22.3697 3.86945L23.1048 4.07673L23.2694 3.49314L21.0981 2.88086L20.9336 3.46417L21.6533 3.66752L21.0978 5.63795L21.8142 5.84017Z" fill="white" />
                      <path d="M24.8925 4.22687L24.238 3.87256L23.5703 5.10522C23.1352 5.90888 23.3429 6.46011 24.0114 6.82184C24.7211 7.20636 25.3234 7.06244 25.736 6.30054L26.413 5.05028L25.7585 4.6957L25.0721 5.96325C24.8639 6.34777 24.6107 6.49279 24.3127 6.33129C24.0149 6.17007 24.0073 5.86163 24.2061 5.49441L24.8925 4.22687Z" fill="white" />
                      <path d="M28.1099 6.36572C27.8765 6.15652 27.6286 5.96414 27.368 5.79004L25.6357 7.75357L26.1878 8.24054L26.8418 7.4995L26.942 7.58822C27.1282 7.75219 27.1661 7.86975 27.0173 8.16363C26.9146 8.35132 26.8316 8.54911 26.7695 8.75387L27.3364 9.25374C27.3658 9.14333 27.5559 8.79122 27.6677 8.52755C27.7169 8.4394 27.7467 8.34167 27.7548 8.24101C27.763 8.14035 27.7494 8.03912 27.7149 7.94418L27.7254 7.93237C27.8563 7.98654 28.0006 7.99971 28.1392 7.97014C28.2778 7.94057 28.4041 7.86965 28.5015 7.76675C28.5802 7.6863 28.6376 7.58763 28.6688 7.47956C28.7 7.37149 28.704 7.25737 28.6803 7.1474C28.5751 6.83436 28.3759 6.5614 28.1099 6.36572ZM27.9129 7.32071C27.78 7.4715 27.5721 7.44541 27.3535 7.2526L27.1881 7.10675L27.5894 6.65219C27.6688 6.7041 27.7434 6.76292 27.8124 6.82797C28.0014 6.99442 28.0459 7.1702 27.9129 7.32071Z" fill="white" />
                      <path d="M27.5498 9.46036L28.006 10.0976L28.6295 9.85916L29.0786 10.4868L28.6682 11.0226L29.1494 11.695L30.7869 9.42355L30.1959 8.59766L27.5498 9.46036ZM29.7526 9.6897L29.454 10.0778L29.1332 9.62955L29.5842 9.46145C29.7344 9.40735 29.9141 9.32687 30.0643 9.27304L30.0687 9.27908C29.9715 9.40707 29.8465 9.56418 29.7526 9.6897Z" fill="white" />
                      <path d="M31.7791 11.083L29.3438 12.1388L30.0958 13.8733L30.6665 13.6258L30.2108 12.5745L32.0752 11.7659L31.7791 11.083Z" fill="white" />
                      <path d="M31.7453 14.992C31.6353 15.0126 31.538 15.076 31.4748 15.1683C31.4115 15.2606 31.3875 15.3742 31.408 15.4842C31.5628 16.3139 31.6406 17.1561 31.6405 18.0001C31.6443 19.8647 31.262 21.7099 30.5175 23.4194C30.4728 23.522 30.4708 23.6381 30.5117 23.7422C30.5527 23.8464 30.6334 23.9299 30.736 23.9746C30.8386 24.0193 30.9547 24.0213 31.0588 23.9803C31.163 23.9394 31.2465 23.8587 31.2912 23.7561C32.0819 21.9404 32.4882 19.9806 32.4843 18.0001C32.4843 17.1041 32.4017 16.2101 32.2375 15.3293C32.2273 15.2749 32.2066 15.2229 32.1763 15.1765C32.1461 15.1301 32.107 15.0901 32.0613 15.0587C32.0156 15.0274 31.9642 15.0054 31.9099 14.994C31.8557 14.9825 31.7998 14.9819 31.7453 14.992Z" fill="white" />
                      <path d="M3.76243 15.3293C3.59827 16.2101 3.51566 17.1041 3.51565 18.0001C3.5124 19.8988 3.88567 21.7793 4.61387 23.5328C4.63511 23.584 4.66623 23.6304 4.70543 23.6696C4.74464 23.7087 4.79117 23.7398 4.84237 23.7609C4.89357 23.7821 4.94844 23.7929 5.00384 23.7929C5.05924 23.7928 5.11408 23.7819 5.16524 23.7606C5.21641 23.7394 5.26289 23.7083 5.30202 23.6691C5.34116 23.6299 5.3722 23.5833 5.39335 23.5321C5.41451 23.4809 5.42537 23.4261 5.42532 23.3707C5.42527 23.3153 5.41432 23.2604 5.39307 23.2093C4.70764 21.5582 4.35631 19.7877 4.3594 18.0001C4.3594 17.1561 4.43723 16.3139 4.59189 15.4842C4.60207 15.4298 4.60141 15.3738 4.58996 15.3196C4.57852 15.2654 4.55651 15.214 4.52519 15.1683C4.49387 15.1226 4.45385 15.0835 4.40743 15.0532C4.361 15.023 4.30908 15.0022 4.25461 14.992C4.20015 14.9819 4.14422 14.9825 4.09001 14.994C4.0358 15.0054 3.98437 15.0274 3.93867 15.0587C3.89296 15.0901 3.85388 15.1301 3.82364 15.1765C3.7934 15.2229 3.7726 15.2749 3.76243 15.3293Z" fill="white" />
                      <path d="M11.6624 7.67859C11.7347 7.67848 11.8043 7.65052 11.8565 7.6005C11.9088 7.55048 11.9398 7.48225 11.9431 7.40997L12.108 3.76361C12.1114 3.6891 12.085 3.6163 12.0347 3.56124C12.0097 3.53397 11.9797 3.51189 11.9462 3.49623C11.9128 3.48058 11.8766 3.47167 11.8397 3.47001C11.8028 3.46835 11.7659 3.47398 11.7312 3.48656C11.6965 3.49915 11.6646 3.51845 11.6373 3.54337C11.5822 3.59369 11.5494 3.66383 11.5461 3.73835L11.3811 7.38471C11.3778 7.4592 11.4042 7.53197 11.4545 7.58702C11.5048 7.64208 11.5749 7.67491 11.6493 7.67832C11.6537 7.67859 11.658 7.67859 11.6624 7.67859Z" fill="white" />
                      <path d="M10.657 4.37076C10.5551 4.32547 10.4446 4.30261 10.3331 4.30375C10.2216 4.30489 10.1116 4.32999 10.0107 4.37735C9.8134 4.48519 9.66674 4.66665 9.60269 4.88217C9.53863 5.09769 9.56237 5.3298 9.66874 5.52789C9.76452 5.73124 9.93053 5.89315 10.1362 5.98382C10.2373 6.02778 10.3463 6.05058 10.4565 6.05084C10.5691 6.05119 10.6804 6.02613 10.7821 5.97751C10.882 5.92804 10.9701 5.85764 11.0404 5.77111C11.1108 5.68457 11.1617 5.58392 11.1897 5.47598C11.2447 5.25853 11.2215 5.02865 11.1241 4.82659C11.0267 4.62453 10.8613 4.46317 10.657 4.37076ZM10.6468 5.32849C10.6411 5.35908 10.6282 5.3879 10.6093 5.41262C10.5904 5.43733 10.5659 5.45726 10.5379 5.47078C10.5098 5.48431 10.479 5.49105 10.4479 5.49048C10.4167 5.4899 10.3862 5.48202 10.3587 5.46747C10.2779 5.42982 10.213 5.36484 10.1755 5.284C10.1356 5.21963 10.1216 5.14251 10.1363 5.06823C10.1511 4.99395 10.1935 4.92803 10.255 4.88382C10.2803 4.87182 10.308 4.86572 10.336 4.86597C10.3698 4.8665 10.4032 4.87379 10.4342 4.88739C10.5143 4.92605 10.5789 4.99071 10.6175 5.07082C10.6561 5.15093 10.6664 5.24176 10.6468 5.32849Z" fill="white" />
                      <path d="M13.3273 4.88085C13.2258 4.83441 13.1152 4.81092 13.0036 4.81205C12.8919 4.81318 12.7819 4.83891 12.6813 4.88739C12.5807 4.93588 12.492 5.00593 12.4216 5.09258C12.3512 5.17922 12.3007 5.28032 12.2737 5.38869C12.2167 5.60595 12.24 5.83649 12.3392 6.03798C12.4089 6.19028 12.5198 6.32002 12.6595 6.41245C12.7991 6.50489 12.9619 6.55633 13.1293 6.56093C13.2413 6.56126 13.3518 6.53618 13.4527 6.4876C13.6501 6.37975 13.7968 6.19824 13.8608 5.98266C13.9249 5.76707 13.9011 5.5349 13.7947 5.33678C13.6987 5.13366 13.5328 4.97162 13.3273 4.88085ZM13.2085 5.98085C13.1357 6.00172 13.0576 5.99399 12.9902 5.95923C12.9228 5.92447 12.8712 5.86531 12.846 5.79382C12.8061 5.71412 12.7956 5.62284 12.8166 5.5362C12.8237 5.50612 12.8371 5.47789 12.8559 5.45337C12.8747 5.42885 12.8984 5.40859 12.9256 5.39392C12.9509 5.38193 12.9785 5.37582 13.0064 5.37607C13.0402 5.37661 13.0736 5.38389 13.1046 5.39749C13.1855 5.43501 13.2505 5.50003 13.2879 5.58096C13.3279 5.64526 13.3419 5.72233 13.3271 5.79657C13.3124 5.87082 13.27 5.93669 13.2085 5.98085Z" fill="white" />
                    </svg>
                  </button>
                  <button className="!w-12 !h-15 !bg-white/20 !backdrop-blur !border !border-white !rounded-full !flex !items-center !justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                      <path d="M27.3332 15.7569C26.9657 15.0316 26.3519 14.4608 25.6017 14.1469C25.6993 13.27 25.4681 12.3881 24.9528 11.6719C24.4375 10.9557 23.6748 10.4562 22.8123 10.2701C22.3059 10.1612 21.7818 10.1636 21.2764 10.2772C21.1197 10.3126 20.9656 10.359 20.8153 10.4159C20.4835 9.98523 20.0571 9.63661 19.5691 9.39702C19.0811 9.15743 18.5445 9.03328 18.0009 9.03418C17.4572 9.03509 16.9211 9.16101 16.4339 9.40222C15.9466 9.64344 15.5214 9.99347 15.1911 10.4253C15.0326 10.3641 14.8699 10.3147 14.7041 10.2775C14.1505 10.1524 13.5751 10.1614 13.0257 10.3037C12.4762 10.4461 11.9688 10.7176 11.5456 11.0958C11.1224 11.474 10.7957 11.9478 10.5927 12.4778C10.3897 13.0078 10.3163 13.5786 10.3785 14.1428C9.78383 14.3954 9.27305 14.8117 8.90557 15.3432C8.5381 15.8747 8.32902 16.4996 8.30265 17.1452C8.27628 17.7908 8.4337 18.4306 8.7566 18.9903C9.07951 19.55 9.55464 20.0066 10.1268 20.3069C10.0825 21.8115 10.5829 23.2815 11.5361 24.4466C12.4892 25.6117 13.8309 26.3935 15.3144 26.6482C16.0764 26.7446 16.8461 26.7637 17.6119 26.7051L17.6114 29.1561C17.6114 29.268 17.6558 29.3753 17.7349 29.4544C17.8141 29.5336 17.9214 29.578 18.0333 29.578C18.1451 29.578 18.2524 29.5336 18.3316 29.4544C18.4107 29.3753 18.4551 29.268 18.4551 29.1561L18.4557 26.713C21.8711 27.0319 25.3235 24.674 25.8563 21.5451C25.9262 21.1249 25.9528 20.6986 25.9356 20.2729C26.7071 19.8468 27.2835 19.1384 27.5441 18.2965C27.8047 17.4545 27.7291 16.5444 27.3332 15.7569ZM25.0247 21.4033C24.5495 24.1939 21.1921 26.3368 18.114 25.8182C18.0648 25.8086 18.0143 25.808 17.9649 25.8163H17.9643L17.9632 25.8166C17.1307 25.9182 16.2887 25.9182 15.4561 25.8166C14.0976 25.5852 12.8791 24.8429 12.0505 23.7417C11.2219 22.6406 10.8461 21.2641 11.0001 19.8946C11.7828 19.8094 12.5746 19.8956 13.3205 20.1475C14.0665 20.3993 14.7486 20.8106 15.3194 21.3528C15.377 21.4078 15.4491 21.4454 15.5272 21.4611C15.6053 21.4769 15.6863 21.4702 15.7607 21.4418C15.8352 21.4134 15.9001 21.3646 15.9479 21.3008C15.9958 21.2371 16.0246 21.1611 16.031 21.0817C16.0897 20.3495 16.2976 19.637 16.6421 18.9882C16.9865 18.3393 17.4602 17.7679 18.0338 17.309C18.6075 17.7679 19.0811 18.3393 19.4256 18.9882C19.77 19.637 19.978 20.3495 20.0366 21.0817C20.0431 21.1611 20.0719 21.2371 20.1197 21.3008C20.1675 21.3646 20.2324 21.4134 20.3069 21.4418C20.3814 21.4702 20.4623 21.4769 20.5405 21.4611C20.6186 21.4454 20.6906 21.4078 20.7483 21.3528C21.3189 20.8103 22.001 20.3988 22.747 20.147C23.4929 19.8951 24.2849 19.809 25.0675 19.8946C25.1242 20.3971 25.1097 20.905 25.0247 21.4033ZM25.822 19.3477C25.7941 19.2847 25.7511 19.2297 25.6968 19.1873C25.6426 19.1449 25.5787 19.1166 25.5109 19.1047C24.6843 18.9673 23.8386 18.9968 23.0236 19.1916C22.2086 19.3864 21.4409 19.7425 20.7659 20.2388C20.4455 18.7033 19.5572 17.3455 18.2785 16.437C18.2071 16.3861 18.1216 16.3587 18.0338 16.3587C17.9461 16.3587 17.8606 16.3861 17.7891 16.437C16.5105 17.3455 15.6221 18.7033 15.3018 20.2388C14.6267 19.7425 13.859 19.3865 13.044 19.1917C12.2291 18.9969 11.3834 18.9674 10.5568 19.1047C10.4822 19.118 10.4126 19.1513 10.3555 19.201C10.2983 19.2507 10.2558 19.3151 10.2324 19.3871C9.83878 19.1091 9.53119 18.7262 9.34465 18.2818C9.15811 17.8375 9.10013 17.3498 9.17731 16.8741C9.2545 16.3984 9.46375 15.954 9.78122 15.5915C10.0987 15.229 10.5116 14.9629 10.9729 14.8236C11.0745 14.7917 11.1605 14.723 11.2139 14.6309C11.2673 14.5387 11.2843 14.43 11.2616 14.326C11.1653 13.8794 11.183 13.4158 11.3132 12.978C11.4434 12.5401 11.6817 12.1421 12.0063 11.8207C12.3309 11.4993 12.7312 11.2649 13.1703 11.139C13.6094 11.0132 14.0732 11 14.5187 11.1006C14.7366 11.1494 14.9472 11.226 15.1455 11.3286C15.2402 11.3778 15.35 11.3891 15.4528 11.3605C15.5555 11.3319 15.6436 11.2653 15.6992 11.1743C15.9943 10.6914 16.4332 10.3132 16.9543 10.0927C17.4755 9.87228 18.0526 9.82067 18.6046 9.94516C18.9551 10.0236 19.2862 10.1718 19.5784 10.3808C19.8705 10.5898 20.1176 10.8555 20.305 11.1619C20.3602 11.2526 20.4476 11.3192 20.5497 11.3482C20.6519 11.3773 20.7612 11.3668 20.8559 11.3187C21.0482 11.2213 21.2518 11.1479 21.4621 11.1004C21.8479 11.014 22.2478 11.012 22.6344 11.0946C23.3366 11.2464 23.9503 11.6698 24.3414 12.2726C24.7324 12.8753 24.8691 13.6083 24.7215 14.3114C24.7196 14.3183 24.7176 14.3251 24.7163 14.3312C24.6921 14.4361 24.709 14.5464 24.7635 14.6393C24.8179 14.7321 24.9059 14.8007 25.0093 14.8308C25.3464 14.9298 25.6597 15.0968 25.9298 15.3215C26.2 15.5461 26.4213 15.8237 26.5801 16.1371C26.8525 16.6757 26.9258 17.2933 26.7871 17.8807C26.6484 18.4682 26.3066 18.9877 25.822 19.3477Z" fill="white" />
                      <path d="M6.28172 13.5013L6.58772 12.7458L3.87619 11.647L3.62109 12.2767L3.63994 13.2366L4.27078 13.3463L4.25109 12.6876L4.25447 12.6794L6.28172 13.5013Z" fill="white" />
                      <path d="M7.78715 10.8045C8.29857 10.0805 7.91707 9.38118 7.26311 8.91921C6.61272 8.45943 5.82252 8.33062 5.31358 9.0505C4.80464 9.77065 5.18999 10.4727 5.84036 10.9322C6.49406 11.3944 7.28069 11.5208 7.78715 10.8045ZM5.81703 9.40645C5.95189 9.21529 6.26802 9.25155 6.77504 9.6097C7.28178 9.96786 7.42515 10.2565 7.29277 10.4438C7.15517 10.6386 6.83517 10.5998 6.32844 10.2414C5.82143 9.88326 5.6819 9.59733 5.81703 9.40645Z" fill="white" />
                      <path d="M9.69517 8.66813C10.3571 8.07899 10.1434 7.31132 9.61112 6.71312C9.08158 6.11848 8.3411 5.81416 7.68247 6.40056C7.02384 6.98668 7.24027 7.75764 7.76981 8.35228C8.3021 8.95048 9.03983 9.25151 9.69517 8.66813ZM8.40153 7.79005C7.98872 7.32643 7.9173 7.01633 8.09226 6.86088C8.26694 6.70543 8.5666 6.81199 8.97941 7.27562C9.39222 7.73924 9.46638 8.0529 9.29499 8.20506C9.117 8.36381 8.81406 8.25395 8.40153 7.79005Z" fill="white" />
                      <path d="M15.3734 4.16879C15.4478 4.97958 16.0592 5.63299 17.2822 5.52038C17.5765 5.50307 17.8645 5.42744 18.1293 5.29791L17.9398 4.66043C17.7429 4.7489 17.5325 4.80332 17.3174 4.82138C16.6948 4.87851 16.3075 4.54837 16.2597 4.02871C16.2045 3.42831 16.6272 3.11355 17.1337 3.06712C17.3592 3.04478 17.5868 3.0669 17.8038 3.13222L17.9184 2.46177C17.634 2.37485 17.3343 2.35003 17.0395 2.38899C16.0493 2.48019 15.277 3.12041 15.3734 4.16879Z" fill="white" />
                      <path d="M18.6423 3.88249C18.6018 4.08864 18.6052 4.301 18.6521 4.50577C18.6991 4.71054 18.7886 4.90315 18.9148 5.07109C19.041 5.23903 19.2011 5.37855 19.3848 5.48059C19.5684 5.58263 19.7714 5.6449 19.9807 5.66337C21.0112 5.83091 21.7539 5.27198 21.9008 4.36588C22.0437 3.48642 21.5501 2.73606 20.5374 2.57182C20.3261 2.52293 20.1069 2.51872 19.8939 2.55944C19.6808 2.60017 19.4786 2.68494 19.3002 2.80832C19.1218 2.9317 18.9711 3.09097 18.8578 3.27595C18.7446 3.46092 18.6711 3.66751 18.6423 3.88249ZM21.0046 4.24339C20.9209 4.75864 20.588 5.09648 20.1304 5.02233C19.6775 4.94872 19.4553 4.52052 19.5388 4.00527C19.6226 3.49002 19.9703 3.14531 20.4188 3.2181C20.8673 3.29088 21.0881 3.72814 21.0046 4.24339Z" fill="white" />
                      <path d="M22.759 3.83261L23.5426 4.17433L22.6074 6.31886L23.3868 6.65861L24.3222 4.51408L25.1221 4.86283L25.3991 4.22748L23.0358 3.19727L22.759 3.83261Z" fill="white" />
                      <path d="M25.89 8.23571L27.3002 6.36989L27.9963 6.89639L28.4139 6.34374L26.3583 4.78955L25.9406 5.34193L26.6221 5.85718L25.2119 7.72299L25.89 8.23571Z" fill="white" />
                      <path d="M30.0189 10.4802C30.714 9.92294 30.85 9.03497 30.2081 8.23461C30.0839 8.0568 29.9239 7.90688 29.7384 7.79446C29.5529 7.68204 29.346 7.60958 29.1309 7.58174C28.9158 7.55389 28.6972 7.57127 28.4892 7.63276C28.2812 7.69424 28.0883 7.79848 27.9229 7.93881C27.7549 8.06482 27.6151 8.22476 27.5129 8.40826C27.4106 8.59175 27.348 8.79471 27.3292 9.00394C27.3105 9.21318 27.3359 9.42403 27.4039 9.62281C27.4718 9.82158 27.5809 10.0038 27.7238 10.1578C28.377 10.9721 29.3028 11.0548 30.0189 10.4802ZM28.5063 8.63012C28.9136 8.30383 29.4028 8.28075 29.6871 8.63506C29.9713 8.98992 29.8425 9.46233 29.4355 9.78863C29.0282 10.1155 28.5547 10.1435 28.2646 9.78176C27.9773 9.42361 28.0993 8.95696 28.5063 8.63012Z" fill="white" />
                      <path d="M30.7913 13.4507L30.786 13.4383C31.0934 13.1478 31.3791 12.8353 31.641 12.5033L32.2604 11.7055L31.8517 10.7197L29.0488 11.8826L29.3507 12.6105L30.1076 12.2963C30.5317 12.1205 30.9377 11.9472 31.3532 11.7502L31.3601 11.767C31.0565 12.0826 30.7691 12.4133 30.499 12.758L29.7822 13.6501L30.1392 14.5108L32.9421 13.3482L32.64 12.6204L31.9083 12.9239C31.5252 13.0757 31.1521 13.2517 30.7913 13.4507Z" fill="white" />
                      <path d="M11.9222 3.18414L11.7571 6.8305C11.7555 6.8674 11.7611 6.90426 11.7737 6.93899C11.7863 6.97371 11.8056 7.00562 11.8305 7.03288C11.8554 7.06015 11.8854 7.08224 11.9189 7.09789C11.9524 7.11354 11.9886 7.12245 12.0255 7.12411C12.0296 7.12439 12.034 7.12439 12.0384 7.12439C12.1107 7.12429 12.1802 7.09632 12.2325 7.0463C12.2848 6.99628 12.3158 6.92805 12.3191 6.85578L12.4841 3.20942C12.4858 3.17252 12.4802 3.13565 12.4676 3.10093C12.455 3.0662 12.4357 3.0343 12.4108 3.00703C12.3859 2.97977 12.3558 2.95768 12.3224 2.94203C12.2889 2.92638 12.2527 2.91747 12.2158 2.91581C12.2117 2.91553 12.2073 2.91553 12.2029 2.91553C12.1305 2.91563 12.061 2.9436 12.0087 2.99362C11.9565 3.04364 11.9255 3.11187 11.9222 3.18414Z" fill="white" />
                      <path d="M10.8364 5.49696C10.9483 5.49728 11.0588 5.47221 11.1597 5.42362C11.3571 5.31583 11.5038 5.13434 11.568 4.91875C11.6321 4.70315 11.6083 4.47095 11.5019 4.2728L11.5016 4.27252C11.4131 4.06565 11.2463 3.90226 11.0376 3.81811C10.8289 3.73395 10.5954 3.73587 10.3881 3.82346C10.2883 3.87292 10.2002 3.94328 10.1299 4.02977C10.0597 4.11626 10.0088 4.21686 9.98083 4.32473C9.92374 4.54197 9.94695 4.77252 10.0462 4.97402C10.116 5.12627 10.2269 5.25595 10.3666 5.34837C10.5062 5.44079 10.669 5.49226 10.8364 5.49696ZM10.5236 4.47221C10.5307 4.44215 10.5441 4.41393 10.5629 4.38941C10.5817 4.36489 10.6054 4.34462 10.6326 4.32993C10.658 4.31798 10.6858 4.31188 10.7139 4.31208C10.7749 4.31761 10.8333 4.33958 10.8828 4.37567C10.9324 4.41175 10.9712 4.46058 10.9951 4.51698C11.0215 4.54649 11.0406 4.58172 11.051 4.61987C11.0613 4.65803 11.0627 4.69808 11.055 4.73687C11.0473 4.77565 11.0306 4.8121 11.0064 4.84335C10.9821 4.87461 10.951 4.8998 10.9154 4.91696C10.8797 4.93411 10.8406 4.94275 10.801 4.94219C10.7615 4.94164 10.7226 4.93191 10.6875 4.91377C10.6523 4.89562 10.6219 4.86956 10.5986 4.83764C10.5752 4.80573 10.5596 4.76882 10.5529 4.72984C10.513 4.65013 10.5026 4.55886 10.5236 4.47221Z" fill="white" />
                      <path d="M13.7049 4.32709C13.6034 4.28067 13.4928 4.2572 13.3812 4.25834C13.2695 4.25948 13.1595 4.28521 13.0589 4.33369C12.9583 4.38217 12.8697 4.45222 12.7992 4.53885C12.7288 4.62549 12.6783 4.72658 12.6513 4.83494C12.5962 5.05244 12.6194 5.2824 12.7168 5.48452C12.8143 5.68664 12.9797 5.84804 13.1842 5.94043C13.2853 5.9844 13.3944 6.00721 13.5047 6.00745C13.6174 6.00783 13.7288 5.98266 13.8304 5.93384C13.9303 5.88438 14.0184 5.81402 14.0886 5.72754C14.1589 5.64105 14.2098 5.54046 14.2378 5.43259C14.2929 5.21509 14.2697 4.98513 14.1723 4.78301C14.0748 4.58089 13.9094 4.41949 13.7049 4.32709ZM13.695 5.2851C13.6893 5.31569 13.6764 5.34451 13.6575 5.36922C13.6386 5.39392 13.6141 5.41383 13.5861 5.42734C13.558 5.44084 13.5272 5.44755 13.4961 5.44694C13.4649 5.44632 13.4344 5.4384 13.4069 5.4238C13.3268 5.38514 13.2622 5.32048 13.2236 5.24037C13.185 5.16026 13.1747 5.06943 13.1943 4.9827C13.2013 4.95256 13.2147 4.92426 13.2335 4.89968C13.2523 4.8751 13.2761 4.85481 13.3034 4.84015C13.3286 4.82815 13.3562 4.82205 13.3841 4.8223C13.4179 4.82286 13.4512 4.83015 13.4822 4.84372C13.563 4.88125 13.628 4.94626 13.6654 5.02719L13.6657 5.02747C13.7056 5.10717 13.716 5.19845 13.695 5.2851Z" fill="white" />
                      <path d="M31.7172 14.9143C31.6628 14.925 31.6111 14.9462 31.5649 14.9768C31.5187 15.0074 31.4791 15.0469 31.4482 15.0928C31.4172 15.1388 31.3957 15.1904 31.3847 15.2447C31.3738 15.299 31.3736 15.3549 31.3843 15.4093C31.7459 17.2754 31.7135 19.1966 31.2889 21.0494C30.8644 22.9023 30.0572 24.6459 28.9191 26.1685C27.781 27.691 26.3372 28.9588 24.6803 29.8905C23.0234 30.8221 21.1901 31.3971 19.2979 31.5785C17.4057 31.7599 15.4964 31.5437 13.6927 30.9438C11.889 30.3439 10.2306 29.3736 8.82398 28.095C7.41736 26.8164 6.29358 25.2579 5.52475 23.5194C4.75592 21.781 4.35903 19.901 4.35955 18.0001C4.36164 17.1303 4.44755 16.2626 4.61608 15.4093C4.63757 15.2995 4.61457 15.1857 4.55215 15.0929C4.52124 15.0469 4.48158 15.0075 4.43543 14.9769C4.38928 14.9462 4.33756 14.925 4.2832 14.9143C4.17342 14.8929 4.05961 14.9159 3.96679 14.9783C3.87397 15.0407 3.80975 15.1375 3.78826 15.2472C3.40399 17.2288 3.43825 19.2689 3.88886 21.2365C4.33946 23.2041 5.19646 25.0558 6.40484 26.6726C7.61323 28.2895 9.1463 29.6359 10.9057 30.6254C12.6651 31.6149 14.6119 32.2256 16.6212 32.4183C18.6305 32.6111 20.6579 32.3816 22.5733 31.7447C24.4887 31.1077 26.2498 30.0774 27.7436 28.7197C29.2373 27.3621 30.4307 25.7071 31.2471 23.8611C32.0636 22.015 32.4851 20.0187 32.4846 18.0001C32.4824 17.0759 32.3911 16.154 32.2121 15.2472C32.2016 15.1928 32.1805 15.141 32.1499 15.0947C32.1193 15.0485 32.0799 15.0088 32.0339 14.9778C31.9879 14.9469 31.9362 14.9253 31.8819 14.9144C31.8275 14.9036 31.7715 14.9035 31.7172 14.9143Z" fill="white" />
                    </svg>
                  </button>
                </div>

              </div>
              <div className="!w-full flex !flex-col !justify-between !p-[24px] ">
                <div className="!border !border-[#585834] !px-4 !py-2 !inline-block !w-fit !rounded-[2px] ">
                  <span className="!font-arbutus !text-[#585834]">Our Cotton Promise</span>
                </div>
                <div className="!space-y-4 md:!py-[0px] !py-[24px]">
                  <p className="!font-arbutus !text-[#585834] !leading-relaxed">
                    At Luna Leaf, comfort begins with the fabric. Our maternity wear is crafted from 100% premium-grade cotton, chosen for its feather-light texture, natural breathability, and buttery-soft touch.
                  </p>
                  <p className="!font-arbutus !text-[#585834] !leading-relaxed">
                    Each garment is woven with love—ensuring it stretches gently as you grow, stays cool through changing temperatures, and soothes even the most sensitive skin.
                  </p>
                  <p className="!font-arbutus !text-[#585834] !leading-relaxed">
                    No itchiness. No clinginess. Just a cloud-like feel that moves with you, from bump to baby.
                  </p>
                </div>
                <Link href="/" className="">
                  <Image
                    src='https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/uploads/AIf4oSmtfOHqW7lGzLH1VmEW2R177u1PBS3dBZaI.webp'
                    alt="Logo"
                    width={200}
                    height={150}
                    className="w-[140px]"
                  />
                </Link>
              </div>
            </div>
          </div>
        </section>


        <section className="section-padding bg-white md:!py-[100px] !py-[30px]">
          <div className="max-w-7xl mx-auto !px-[16px]">
            <div className="!flex !justify-between !items-center !mb-[10px]">
              <h2 className="!text-[20px] font-arbutus !font-semibold">
                {/* {featuredcategoriesListData?.[0]?.name || 'Maternity Kurthis'} */}
                Maternity Kurthis
              </h2>
              <button className="!bg-black !text-white !text-[14px] !rounded-tl-[32px] !rounded-br-[32px] !px-[24px] !py-2 !rounded-sm !font-arbutus hover:!bg-black/90">
                <a href="/products/new-arrivals">View All</a>
              </button>
            </div>
            <div className="relative">
              <Swiper
                modules={[Navigation, Autoplay]}
                loop={true}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                navigation={{
                  nextEl: ".custom-next",
                  prevEl: ".custom-prev",
                }}
                spaceBetween={24}
                slidesPerView={2}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                }}
                className=""
              >
                {featuredcategoriesListData?.[0]?.products?.map((product: any) => {
                  // Handle image URLs safely
                  const images = product.imageurl
                    ? product.imageurl
                      .split(',')
                      .map(
                        (url: any) =>
                          `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/${url.trim()}`
                      )
                    : [];

                  // Calculate savings
                  const savings = Math.round(
                    ((parseFloat(product?.mrp || 1) - parseFloat(product?.sp || 0)) /
                      parseFloat(product?.mrp || 1)) *
                    100
                  );

                  return (
                    <SwiperSlide key={product.id}>
                      <div className="group !cursor-pointer">
                        <div className="!relative bg-muted !rounded !aspect-[382/477] !overflow-hidden !mb-[14px]">
                          <Link href={`/p/${product.seo_url}`}>
                            <img
                              src={
                                images[0] ||
                                'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/vilvabusiness/no-image.webp'
                              }
                              alt={product.name || 'Product'}
                              className="!w-full !h-full !object-cover group-hover:!scale-105 !transition-transform !duration-300"
                            />
                            <span className="!absolute !top-3 !left-3 !bg-white !px-2 !py-1 !text-xs font-arbutus">
                              Buy 3 @ ₹{product?.sp || 0}
                            </span>
                          </Link>
                        </div>
                        <div>
                          <div className="!flex !items-center !justify-between">
                            <h3 className="!font-arbutus !text-[#202020] truncate">
                              {/* {product.name?.length > (isMobile ? 22 : 40)
                                ? product.name.slice(0, isMobile ? 22 : 40) + '...'
                                : product.name || 'Unnamed Product'} */}
                              {product.name || 'Unnamed Product'}
                            </h3>
                            <svg
                              className="cursor-pointer"
                              onClick={async () =>
                                addtowishlist(
                                  product,
                                  productwishlistData,
                                  setproductwishlistData,
                                  navigate
                                )
                              }
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill={
                                productwishlistData?.includes(product?.id?.toString())
                                  ? "#f45440"
                                  : "none"
                              }
                            >
                              <path
                                d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                                stroke="#676767"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <Link href={`/p/${product.seo_url}`}>
                            <div className="!flex !items-center md:!space-x-[12px]  !space-x-[4px]">
                              <p className="!text-sm !font-arbutus !text-[#202020] !line-through whitespace-nowrap">
                                ₹ {product?.mrp || 1}
                              </p>
                              <p className="text-sm font-arbutus !text-[#202020] whitespace-nowrap">
                                ₹ {product?.sp || 0}
                              </p>
                              <p className="text-sm font-arbutus !text-[#409A19] whitespace-nowrap">
                                Save {savings}%
                              </p>
                            </div>
                          </Link>
                          <p className="text-xs font-arbutus !text-[#E82020]">
                            {product.stock || 'In Stock'}
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>

              {/* Custom Nav Buttons with SVG */}
              <button className="custom-prev absolute top-[40%] !left-2 !z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="!w-8 !h-8 !text-black !bg-white !rounded-full !shadow !p-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button className="custom-next absolute top-[40%] !right-2 !z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="!w-8 !h-8 !text-black !bg-white !rounded-full !shadow !p-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </section>


        <section className="section-padding !bg-[#FFFFF2] md:!py-[100px] !py-[30px]">
          <div className="max-w-7xl mx-auto !px-[16px]">
            <div className="!flex !justify-between !items-center !mb-[10px]">
              <h2 className="!text-[20px] font-arbutus !font-semibold">
                {/* {featuredcategoriesListData?.[0]?.name || 'Offer Zone'} */}
                Offer Zone
              </h2>
              <button className="!bg-black !text-white !text-[14px] !rounded-tl-[32px] !rounded-br-[32px] !px-[24px] !py-2 !rounded-sm !font-arbutus hover:!bg-black/90">
                <a href="/products/new-arrivals">View All</a>
              </button>
            </div>
            <div className="relative">
              <Swiper
                modules={[Navigation, Autoplay]}
                loop={true}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                navigation={{
                  nextEl: ".custom-next",
                  prevEl: ".custom-prev",
                }}
                spaceBetween={24}
                slidesPerView={2}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                }}
                className=""
              >
                {featuredcategoriesListData?.[0]?.products?.map((product: any) => {
                  // Handle image URLs safely
                  const images = product.imageurl
                    ? product.imageurl
                      .split(',')
                      .map(
                        (url: any) =>
                          `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/${url.trim()}`
                      )
                    : [];

                  // Calculate savings
                  const savings = Math.round(
                    ((parseFloat(product?.mrp || 1) - parseFloat(product?.sp || 0)) /
                      parseFloat(product?.mrp || 1)) *
                    100
                  );

                  return (
                    <SwiperSlide key={product.id}>
                      <div className="group !cursor-pointer">
                        <div className="!relative bg-muted !rounded !aspect-[382/477] !overflow-hidden !mb-[14px]">
                          <Link href={`/p/${product.seo_url}`}>
                            <img
                              src={
                                images[0] ||
                                'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/vilvabusiness/no-image.webp'
                              }
                              alt={product.name || 'Product'}
                              className="!w-full !h-full !object-cover group-hover:!scale-105 !transition-transform !duration-300"
                            />
                            <span className="!absolute !top-3 !left-3 !bg-white !px-2 !py-1 !text-xs font-arbutus">
                              Buy 3 @ ₹{product?.sp || 0}
                            </span>
                          </Link>
                        </div>
                        <div>
                          <div className="!flex !items-center !justify-between">
                            <h3 className="!font-arbutus !text-[#202020] truncate">
                              {/* {product.name?.length > (isMobile ? 22 : 40)
                              ? product.name.slice(0, isMobile ? 22 : 40) + '...'
                              : product.name || 'Unnamed Product'} */}
                              {product.name || 'Unnamed Product'}
                            </h3>
                            <svg
                              className="cursor-pointer"
                              onClick={async () =>
                                addtowishlist(
                                  product,
                                  productwishlistData,
                                  setproductwishlistData,
                                  navigate
                                )
                              }
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill={
                                productwishlistData?.includes(product?.id?.toString())
                                  ? "#f45440"
                                  : "none"
                              }
                            >
                              <path
                                d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                                stroke="#676767"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <Link href={`/p/${product.seo_url}`}>
                            <div className="!flex !items-center md:!space-x-[12px] !space-x-[4px]">
                              <p className="!text-sm !font-arbutus !text-[#202020] !line-through whitespace-nowrap">
                                ₹ {product?.mrp || 1}
                              </p>
                              <p className="text-sm font-arbutus !text-[#202020] whitespace-nowrap">
                                ₹ {product?.sp || 0}
                              </p>
                              <p className="text-sm font-arbutus !text-[#409A19] whitespace-nowrap">
                                Save {savings}%
                              </p>
                            </div>
                          </Link>
                          <p className="text-xs font-arbutus !text-[#E82020]">
                            {product.stock || 'In Stock'}
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>

              {/* Custom Nav Buttons with SVG */}
              <button className="custom-prev absolute top-[40%] !left-2 !z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="!w-8 !h-8 !text-black !bg-white !rounded-full !shadow !p-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button className="custom-next absolute top-[40%] !right-2 !z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="!w-8 !h-8 !text-black !bg-white !rounded-full !shadow !p-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </section>

        <TestimonialSection />

        {/* <section className="section-padding !bg-white md:!my-[40px] !my-[20px]">
          <div className="">
            <h2 className="!text-3xl !font-arbutus !text-center !mb-[20px]">What Our Moms Say</h2>
            <div className="!flex !items-center !space-x-2 overflow-x-scroll">

              <div className="!flex !justify-center !w-[1600px] !opacity-50 in-active">
                <div className="!max-w-4xl !space-y-[20px] !bg-gradient-to-br !from-yellow-100 !via-yellow-50 !to-yellow-100 !rounded-3xl !p-10 !relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="35" viewBox="0 0 49 35" fill="none">
                    <path d="M29.8203 33.2832L27.6348 30.1064L27.2549 29.5557L27.8916 29.3477C32.6164 27.8069 35.7648 25.738 37.4434 23.1943L37.4453 23.1904C37.7919 22.6759 38.0427 22.2359 38.2051 21.8672C38.3698 21.4932 38.4306 21.2234 38.4307 21.041C38.4307 19.3206 37.9607 18.2528 37.1572 17.668C36.131 16.9805 35.2939 16.3472 34.6523 15.7686L34.4131 15.5586C33.8642 15.0642 33.3755 14.5312 32.9482 13.959C31.8512 12.4899 31.3135 10.7145 31.3135 8.66113C31.3135 6.57675 32.1736 4.69499 33.832 3.0293C35.4765 1.37776 37.2401 0.500021 39.1162 0.5C42.1983 0.5 44.592 1.43986 46.2002 3.3916L46.2031 3.39551C47.75 5.31278 48.5 7.81649 48.5 10.8574C48.4999 16.8715 46.8426 21.9252 43.502 25.9834C40.1657 30.0362 35.7619 32.5386 30.3184 33.4922L30.0029 33.5479L29.8203 33.2832ZM3.77441 33.2832L1.58789 30.1064L1.20898 29.5557L1.84473 29.3477C6.56958 27.8069 9.71791 25.738 11.3965 23.1943L11.3994 23.1904C11.7458 22.6761 11.9959 22.2358 12.1582 21.8672C12.3229 21.4932 12.3838 21.2234 12.3838 21.041C12.3838 19.3205 11.914 18.2527 11.1104 17.668C10.0841 16.9805 9.24704 16.3472 8.60547 15.7686L8.36621 15.5586C7.81746 15.0643 7.3286 14.5311 6.90137 13.959C5.80444 12.4899 5.26758 10.7144 5.26758 8.66113C5.26763 6.57675 6.12672 4.69499 7.78516 3.0293C9.42957 1.37775 11.1932 0.500134 13.0693 0.5C16.1514 0.5 18.5451 1.43986 20.1533 3.3916L20.1562 3.39551C21.7031 5.31278 22.4531 7.81648 22.4531 10.8574C22.453 16.8714 20.7966 21.9252 17.4561 25.9834C14.1199 30.0363 9.71601 32.5385 4.27246 33.4922L3.95605 33.5479L3.77441 33.2832Z" stroke="black" />
                  </svg>
                  <p className="!font-arbutus !text-[#202020] !leading-relaxed !text-[14px]">
                    "Finding maternity clothes that were both stylish and actually comfortable felt impossible—until I discovered Luna Leaf. The like being hugged by your clothes."
                  </p>
                  <div className="!flex !gap-1">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="!w-5 !h-5 !text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" />
                      </svg>
                    ))}
                  </div>
                  <p className="!font-arbutus !text-gray-600 !text-lg">— Ananya R., Bangalore</p>
                </div>
              </div>
              <div className="!flex !justify-center !w-[1600px] active">
                <div className="!max-w-4xl !space-y-[20px] !bg-gradient-to-br !from-yellow-100 !via-yellow-50 !to-yellow-100 !rounded-3xl !p-10 !relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="35" viewBox="0 0 49 35" fill="none">
                    <path d="M29.8203 33.2832L27.6348 30.1064L27.2549 29.5557L27.8916 29.3477C32.6164 27.8069 35.7648 25.738 37.4434 23.1943L37.4453 23.1904C37.7919 22.6759 38.0427 22.2359 38.2051 21.8672C38.3698 21.4932 38.4306 21.2234 38.4307 21.041C38.4307 19.3206 37.9607 18.2528 37.1572 17.668C36.131 16.9805 35.2939 16.3472 34.6523 15.7686L34.4131 15.5586C33.8642 15.0642 33.3755 14.5312 32.9482 13.959C31.8512 12.4899 31.3135 10.7145 31.3135 8.66113C31.3135 6.57675 32.1736 4.69499 33.832 3.0293C35.4765 1.37776 37.2401 0.500021 39.1162 0.5C42.1983 0.5 44.592 1.43986 46.2002 3.3916L46.2031 3.39551C47.75 5.31278 48.5 7.81649 48.5 10.8574C48.4999 16.8715 46.8426 21.9252 43.502 25.9834C40.1657 30.0362 35.7619 32.5386 30.3184 33.4922L30.0029 33.5479L29.8203 33.2832ZM3.77441 33.2832L1.58789 30.1064L1.20898 29.5557L1.84473 29.3477C6.56958 27.8069 9.71791 25.738 11.3965 23.1943L11.3994 23.1904C11.7458 22.6761 11.9959 22.2358 12.1582 21.8672C12.3229 21.4932 12.3838 21.2234 12.3838 21.041C12.3838 19.3205 11.914 18.2527 11.1104 17.668C10.0841 16.9805 9.24704 16.3472 8.60547 15.7686L8.36621 15.5586C7.81746 15.0643 7.3286 14.5311 6.90137 13.959C5.80444 12.4899 5.26758 10.7144 5.26758 8.66113C5.26763 6.57675 6.12672 4.69499 7.78516 3.0293C9.42957 1.37775 11.1932 0.500134 13.0693 0.5C16.1514 0.5 18.5451 1.43986 20.1533 3.3916L20.1562 3.39551C21.7031 5.31278 22.4531 7.81648 22.4531 10.8574C22.453 16.8714 20.7966 21.9252 17.4561 25.9834C14.1199 30.0363 9.71601 32.5385 4.27246 33.4922L3.95605 33.5479L3.77441 33.2832Z" stroke="black" />
                  </svg>
                  <p className="!font-arbutus text-[#202020] !leading-relaxed !text-[14px]">
                    "Finding maternity clothes that were both stylish and actually comfortable felt impossible—until I discovered Luna Leaf. The like being hugged by your clothes."
                  </p>
                  <div className="!flex !gap-1">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="!w-5 !h-5 !text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" />
                      </svg>
                    ))}
                  </div>
                  <p className="!font-arbutus !text-gray-600 !text-lg">— Ananya R., Bangalore</p>
                </div>
              </div>
              <div className="!flex !justify-center !w-[1600px] !opacity-50 in-active">
                <div className="!max-w-4xl !space-y-[20px] !bg-gradient-to-br !from-yellow-100 !via-yellow-50 !to-yellow-100 !rounded-3xl !p-10 !relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="35" viewBox="0 0 49 35" fill="none">
                    <path d="M29.8203 33.2832L27.6348 30.1064L27.2549 29.5557L27.8916 29.3477C32.6164 27.8069 35.7648 25.738 37.4434 23.1943L37.4453 23.1904C37.7919 22.6759 38.0427 22.2359 38.2051 21.8672C38.3698 21.4932 38.4306 21.2234 38.4307 21.041C38.4307 19.3206 37.9607 18.2528 37.1572 17.668C36.131 16.9805 35.2939 16.3472 34.6523 15.7686L34.4131 15.5586C33.8642 15.0642 33.3755 14.5312 32.9482 13.959C31.8512 12.4899 31.3135 10.7145 31.3135 8.66113C31.3135 6.57675 32.1736 4.69499 33.832 3.0293C35.4765 1.37776 37.2401 0.500021 39.1162 0.5C42.1983 0.5 44.592 1.43986 46.2002 3.3916L46.2031 3.39551C47.75 5.31278 48.5 7.81649 48.5 10.8574C48.4999 16.8715 46.8426 21.9252 43.502 25.9834C40.1657 30.0362 35.7619 32.5386 30.3184 33.4922L30.0029 33.5479L29.8203 33.2832ZM3.77441 33.2832L1.58789 30.1064L1.20898 29.5557L1.84473 29.3477C6.56958 27.8069 9.71791 25.738 11.3965 23.1943L11.3994 23.1904C11.7458 22.6761 11.9959 22.2358 12.1582 21.8672C12.3229 21.4932 12.3838 21.2234 12.3838 21.041C12.3838 19.3205 11.914 18.2527 11.1104 17.668C10.0841 16.9805 9.24704 16.3472 8.60547 15.7686L8.36621 15.5586C7.81746 15.0643 7.3286 14.5311 6.90137 13.959C5.80444 12.4899 5.26758 10.7144 5.26758 8.66113C5.26763 6.57675 6.12672 4.69499 7.78516 3.0293C9.42957 1.37775 11.1932 0.500134 13.0693 0.5C16.1514 0.5 18.5451 1.43986 20.1533 3.3916L20.1562 3.39551C21.7031 5.31278 22.4531 7.81648 22.4531 10.8574C22.453 16.8714 20.7966 21.9252 17.4561 25.9834C14.1199 30.0363 9.71601 32.5385 4.27246 33.4922L3.95605 33.5479L3.77441 33.2832Z" stroke="black" />
                  </svg>
                  <p className="!font-arbutus text-[#202020] !leading-relaxed !text-[14px]">
                    "Finding maternity clothes that were both stylish and actually comfortable felt impossible—until I discovered Luna Leaf. The like being hugged by your clothes."
                  </p>
                  <div className="!flex !gap-1">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="!w-5 !h-5 !text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" />
                      </svg>
                    ))}
                  </div>
                  <p className="!font-arbutus !text-gray-600 !text-lg">— Ananya R., Bangalore</p>
                </div>
              </div>

            </div>
          </div>
        </section> */}


        <section>
          <div>
            <Image src="https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/uploads/ljV1ODWyQQWUs9sViUKXTgQiiHtAAzIzFF0gRj0o.webp"
              className="!w-full !h-full hidden md:block " width={1000} height={150} alt="" />
            <Image src="https://assetsvilva.blr1.cdn.digitaloceanspaces.com/LU03502F2509/uploads/jsH8b4UaliGzPL5dtPdRiKsFkhLpYZSS5dt4XauO.webp"
              className="!w-full !h-full md:hidden block" width={1000} height={150} alt="" />
            <div className="!py-[8px] overflow-hidden !bg-[#FFFFD0]">
              <style jsx>{`
        .scroll-banner {
          display: inline-flex;
          animation: scroll 50s linear infinite;
          white-space: nowrap;
        }
        .scroll-banner span {
          margin-right: 60px; /* Adjust spacing between text repetitions */
        }
        @keyframes scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-100%);
          }
        }
      `}</style>

              <div className="scroll-banner">
                {/* Repeat the text enough times to ensure no gap */}
                {Array(10).fill(0).map((_, i) => (
                  <span
                    key={i}
                    className="!text-[#565609] !text-[30px] !font-semibold whitespace-nowrap"
                  >
                    Free Shipping Over 3999/-
                  </span>
                ))}
                {/* Duplicate the content for seamless looping */}
                {Array(10).fill(0).map((_, i) => (
                  <span
                    key={`duplicate-${i}`}
                    className="!text-[#565609] !text-[30px] !font-semibold whitespace-nowrap"
                  >
                    Free Shipping Over 3999/-
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>


        <section className="section-padding bg-white !py-[40px]">
          <div className="max-w-7xl mx-auto !px-[16px]">
            <h2 className="!text-3xl !font-arbutus !text-center !mb-[20px]">Luna Looks You'll Love</h2>
            <Swiper
              modules={[Autoplay]}
              spaceBetween={24}
              slidesPerView={1.4}
              breakpoints={{
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 5 },
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              pagination={{ clickable: true }}
              className="!grid !grid-cols-2 md:!grid-cols-3 lg:!grid-cols-5 !gap-6"
            >
              {[
                "https://api.builder.io/api/v1/image/assets/TEMP/038f1c7283bb12080678d4ea6fd09c6bea0208cd?width=674",
                "https://api.builder.io/api/v1/image/assets/TEMP/110918935de1fd20a96f12a4af6242d4011b7059?width=674",
                "https://api.builder.io/api/v1/image/assets/TEMP/16c6e53e6831bbb565da7fb055b4397718a96e5c?width=674",
                "https://api.builder.io/api/v1/image/assets/TEMP/038f1c7283bb12080678d4ea6fd09c6bea0208cd?width=674",
                "https://api.builder.io/api/v1/image/assets/TEMP/ad00705d1ccd7b7d7ea5d939543cfddbf1a0045f?width=674"
              ].map((image, index) => (
                <SwiperSlide key={index}>
                  <div className="!relative group !cursor-pointer">
                    <div className="aspect-[337/607] !overflow-hidden !rounded">
                      <img
                        src={image}
                        alt={`Look ${index + 1}`}
                        className="!w-full !h-full !object-cover group-hover:!scale-105 !transition-transform !duration-300"
                      />
                    </div>
                    <div className="!absolute !top-3 !bg-[#E82020] !left-3 !text-white !px-2 !py-1 !text-xs !font-arbutus !rounded">
                      32% Off
                    </div>
                    <button className="!absolute !bottom-3 !left-3 !right-3 !bg-white !text-[#202020] !py-2 !rounded !text-sm ~font-arbutus hover:!bg-gray-50 !transition-colors">
                      Shop Now
                    </button>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>

        <section className="section-padding bg-white md:!py-[50px] !py-[30px] !px-[16px]">
          <div className="!max-w-6xl mx-auto">
            <div className="!flex !flex-col md:!flex-row">
              <div className="relative !w-full">
                <img
                  src="https://api.builder.io/api/v1/image/assets/TEMP/bce78f36c5ca607c366adc52dbda0b00a0f11467?width=1576"
                  alt="Our story"
                  className="!w-full md:!h-[550px] !h-[500px] !object-cover !rounded"
                />
                <button className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-white/40 backdrop-blur rounded-full flex items-center justify-center hover:bg-white/60 transition-colors">
                  <svg className="w-8 h-8 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </button>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
                  {[0, 1, 2].map((index) => (
                    <div
                      key={index}
                      className={`w-3 h-3 rounded-full ${index === 0 ? 'bg-white' : 'bg-white/40'
                        }`}
                    />
                  ))}
                </div>
              </div>
              <div className="!w-full md:!px-[24px] !p-[0px] ]">
                <h2 className="text-[28px] text-[#202020] ">🌙 Our Story – The Birth of Luna Leaf</h2>
                <div className=" text-luna-sage leading-relaxed space-y-2">
                  <p className="!text-[#585834] text-[16px] ">
                    When our founder, Aanya, was expecting her first child, she searched for maternity wear that was as gentle on the skin as it was elegant to the eye. Everything she found was either uncomfortable, synthetic, or lacked the beauty she believed every mother deserves. So, she decided to create what she couldn't find: maternity wear that felt like a second skin—soft, breathable, and made with love.
                  </p>
                  <p className="!text-[#585834] text-[16px] ">
                    Thus, Luna Leaf was born.
                  </p>
                  <p className="!text-[#585834] text-[16px]">
                    Rooted in the purity of 100% cotton fabrics and inspired by the grace of motherhood, Luna Leaf isn't just a clothing brand. It's a tribute to the strength, softness, and transformation every woman experiences during her journey into motherhood.
                  </p>
                  <p className="!text-[#585834] text-[16px]">
                    From trimester to toddlerhood, every stitch in our garments is made to support your changing body, uplift your spirit, and celebrate your story.
                  </p>
                  <p className="!text-[#585834] text-[16px]">
                    We believe maternity fashion should be more than functional—it should be freeing, flattering, and feel like home.
                  </p>
                  <p className="!text-[#585834] text-[16px] font-medium">
                    Welcome to Luna Leaf. Made with care. Worn with confidence.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 !bg-[#F4FBE4]">
          <div className="container mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              {[
                {
                  icon:
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                      <path d="M56.4705 30.0005C56.4705 27.2829 53.4352 25.0946 52.6411 22.6417C51.8116 20.1182 52.9587 16.5534 51.4234 14.4357C49.8705 12.3005 46.1117 12.3005 43.994 10.7476C41.8763 9.21229 40.7117 5.64755 38.1881 4.81808C35.7352 4.02405 32.7175 6.21226 29.9999 6.21226C27.2999 6.21226 24.2646 4.02405 21.8116 4.81808C19.2881 5.64755 18.1234 9.21229 16.0234 10.7476C13.8881 12.3005 10.1293 12.3005 8.59399 14.4357C7.05871 16.5534 8.18815 20.1005 7.37634 22.6417C6.5822 25.0946 3.5293 27.2829 3.5293 30.0005C3.5293 32.7181 6.5822 34.9064 7.37634 37.3593C8.18815 39.8828 7.05871 43.4475 8.59399 45.5652C10.1293 47.6828 13.8881 47.7005 16.0234 49.2534C18.1234 50.7887 19.2881 54.3534 21.8116 55.1828C24.2646 55.977 27.2999 53.7887 29.9999 53.7887C32.7175 53.7887 35.7352 55.977 38.1881 55.1828C40.7117 54.3534 41.8763 50.7887 43.994 49.2534C46.1117 47.7005 49.8705 47.6828 51.4234 45.5652C52.9587 43.4475 51.8116 39.8828 52.6411 37.3593C53.4352 34.9064 56.4705 32.7181 56.4705 30.0005ZM42.0175 27.2829L36.7057 32.4711L37.9587 39.7946C38.0999 40.571 37.2705 41.1534 36.5646 40.8005L29.9999 37.3416L23.4352 40.8005C22.7293 41.1534 21.9175 40.571 22.041 39.7946L23.294 32.4711L17.9822 27.2829C17.4175 26.7358 17.7352 25.7651 18.5116 25.6592L25.8529 24.6005L29.1529 17.9298C29.4882 17.224 30.5116 17.224 30.8646 17.9298L34.1469 24.6005L41.4881 25.6592C42.2646 25.7651 42.5822 26.7358 42.0175 27.2829Z" fill="url(#paint0_linear_2_116)" />
                      <defs>
                        <linearGradient id="paint0_linear_2_116" x1="29.9999" y1="4.64453" x2="29.9999" y2="55.3564" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                      </defs>
                    </svg>
                  , title: "Best Quality"
                },
                {
                  icon:
                    <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                      <path d="M20.1251 35.375L26.6926 59.9997L4.97852 35.375H20.1251Z" fill="url(#paint0_linear_2_121)" />
                      <path d="M20.2505 31.8572H4.97852L15.0172 21.8185C15.3479 21.489 15.7946 21.3037 16.2613 21.3037H26.2812L20.2505 31.8572Z" fill="url(#paint1_linear_2_121)" />
                      <path d="M36.3642 31.8572H24.3027L30.3334 21.3037L36.3642 31.8572Z" fill="url(#paint2_linear_2_121)" />
                      <path d="M36.8998 35.375L30.3332 59.9997L23.7666 35.375H36.8998Z" fill="url(#paint3_linear_2_121)" />
                      <path d="M40.4145 31.8572L34.3838 21.3037H44.4037C44.8704 21.3037 45.3172 21.489 45.6478 21.8185L55.6865 31.8572H40.4145Z" fill="url(#paint4_linear_2_121)" />
                      <path d="M40.5402 35.375H55.6867L33.9727 59.9997L40.5402 35.375Z" fill="url(#paint5_linear_2_121)" />
                      <path d="M30.3331 10.0295C29.3617 10.0295 28.5742 9.24201 28.5742 8.27062V1.75891C28.5742 0.787522 29.3617 0 30.3331 0C31.3045 0 32.092 0.787522 32.092 1.75891V8.27062C32.092 9.24201 31.3046 10.0295 30.3331 10.0295Z" fill="url(#paint6_linear_2_121)" />
                      <path d="M12.8483 13.6617L9.59246 8.02242C9.10665 7.18119 9.39488 6.10545 10.2362 5.61975C11.0774 5.13406 12.1533 5.42217 12.6389 6.26351L15.8947 11.9028C16.3806 12.744 16.0923 13.8198 15.251 14.3055C14.4133 14.7892 13.3361 14.5068 12.8483 13.6617Z" fill="url(#paint7_linear_2_121)" />
                      <path d="M45.4149 14.3055C44.5736 13.8198 44.2854 12.7441 44.7712 11.9029L48.027 6.26356C48.5128 5.42222 49.5884 5.13399 50.4297 5.6198C51.271 6.1055 51.5593 7.18125 51.0735 8.02247L47.8176 13.6618C47.3304 14.5056 46.2536 14.7898 45.4149 14.3055Z" fill="url(#paint8_linear_2_121)" />
                      <defs>
                        <linearGradient id="paint0_linear_2_121" x1="15.8356" y1="35.375" x2="15.8356" y2="59.9997" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_2_121" x1="15.6299" y1="21.3037" x2="15.6299" y2="31.8572" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_2_121" x1="30.3334" y1="21.3037" x2="30.3334" y2="31.8572" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint3_linear_2_121" x1="30.3332" y1="35.375" x2="30.3332" y2="59.9997" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint4_linear_2_121" x1="45.0352" y1="21.3037" x2="45.0352" y2="31.8572" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint5_linear_2_121" x1="44.8297" y1="35.375" x2="44.8297" y2="59.9997" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint6_linear_2_121" x1="30.3331" y1="0" x2="30.3331" y2="10.0295" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint7_linear_2_121" x1="12.7436" y1="5.38379" x2="12.7436" y2="14.5414" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint8_linear_2_121" x1="47.9223" y1="5.38379" x2="47.9223" y2="14.5414" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                      </defs>
                    </svg>
                  , title: "Value for Money"
                },
                {
                  icon:
                    <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                      <path d="M50.3361 12.4882L32.1861 4.12566L31.9048 4.01316C31.0927 3.80681 30.2419 3.80681 29.4298 4.01316L29.1486 4.12566L10.9986 12.4882C10.1413 12.8829 9.42311 13.5272 8.93802 14.3368C8.45294 15.1464 8.22353 16.0835 8.27983 17.0257L8.91733 27.6757C9.2791 33.8011 11.3749 39.6976 14.9603 44.6773C18.5456 49.657 23.4729 53.5147 29.1673 55.8007C29.6446 56.0155 30.1627 56.1242 30.6861 56.1194C31.1836 56.1271 31.6766 56.0246 32.1298 55.8194C37.8313 53.5391 42.7664 49.6838 46.3587 44.7037C49.9511 39.7235 52.0524 33.8241 52.4173 27.6944L53.0548 17.0444C53.115 16.0992 52.8875 15.1579 52.4021 14.3446C51.9168 13.5313 51.1965 12.884 50.3361 12.4882ZM40.5111 25.6132L30.4986 36.8632C30.3357 37.0496 30.1375 37.2019 29.9155 37.3113C29.6934 37.4207 29.4519 37.4851 29.2048 37.5007H29.1111C28.6399 37.5041 28.1847 37.3301 27.8361 37.0132L20.9548 30.6757C20.5893 30.3375 20.3731 29.868 20.3538 29.3705C20.3345 28.8729 20.5136 28.388 20.8517 28.0225C21.1899 27.657 21.6594 27.4408 22.1569 27.4215C22.6545 27.4022 23.1393 27.5813 23.5048 27.9194L28.9798 32.9632L37.6986 23.1382C38.0333 22.7897 38.4895 22.5839 38.9722 22.5637C39.4549 22.5434 39.9268 22.7103 40.2895 23.0294C40.6522 23.3486 40.8777 23.7955 40.919 24.2768C40.9603 24.7582 40.8141 25.2369 40.5111 25.6132Z" fill="url(#paint0_linear_2_140)" />
                      <defs>
                        <linearGradient id="paint0_linear_2_140" x1="30.6679" y1="3.8584" x2="30.6679" y2="56.1198" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                      </defs>
                    </svg>
                  , title: "Secure Payment"
                },
                {
                  icon:
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                      <path d="M37.5777 9.43262H5.00628C4.04611 9.43262 3.29199 10.1867 3.29199 11.1469V31.7183C3.29199 32.661 4.04611 33.4326 5.00628 33.4326H37.5777C38.5206 33.4326 39.292 32.661 39.292 31.7183V11.1469C39.292 10.1867 38.5207 9.43262 37.5777 9.43262Z" fill="url(#paint0_linear_2_145)" />
                      <path d="M3.27441 42.0043C3.27441 42.947 4.04584 43.7186 4.9887 43.7186H6.84013C7.56013 40.1356 10.5087 37.3243 14.1773 36.8615H5.00584C4.38853 36.8615 3.82316 36.7584 3.27441 36.5527V42.0043Z" fill="url(#paint1_linear_2_145)" />
                      <path d="M52.8854 43.7192H55.0112C55.954 43.7192 56.7254 42.9476 56.7254 42.0049V26.9877C56.7254 24.2961 50.1597 18.0049 46.5599 18.0049H42.7199V31.7192C42.7199 34.5476 40.4054 36.862 37.577 36.862H16.4053C20.074 37.3249 23.0226 40.1361 23.7424 43.7192H35.9824C36.7712 39.7763 40.2512 36.7763 44.434 36.7763C48.5997 36.7761 52.0969 39.7761 52.8854 43.7192ZM45.531 22.2219C54.3083 21.7933 53.9485 30.8619 53.9485 30.8619H45.531V22.2219Z" fill="url(#paint2_linear_2_145)" />
                      <path d="M44.4281 50.5662C47.2874 50.5662 49.6053 48.2483 49.6053 45.3891C49.6053 42.5298 47.2874 40.2119 44.4281 40.2119C41.5689 40.2119 39.251 42.5298 39.251 45.3891C39.251 48.2483 41.5689 50.5662 44.4281 50.5662Z" fill="url(#paint3_linear_2_145)" />
                      <path d="M15.2846 50.5662C18.1438 50.5662 20.4617 48.2483 20.4617 45.3891C20.4617 42.5298 18.1438 40.2119 15.2846 40.2119C12.4253 40.2119 10.1074 42.5298 10.1074 45.3891C10.1074 48.2483 12.4253 50.5662 15.2846 50.5662Z" fill="url(#paint4_linear_2_145)" />
                      <defs>
                        <linearGradient id="paint0_linear_2_145" x1="21.292" y1="9.43262" x2="21.292" y2="33.4326" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_2_145" x1="8.72584" y1="36.5527" x2="8.72584" y2="43.7186" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_2_145" x1="36.5654" y1="18.0049" x2="36.5654" y2="43.7192" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint3_linear_2_145" x1="44.4281" y1="40.2119" x2="44.4281" y2="50.5662" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                        <linearGradient id="paint4_linear_2_145" x1="15.2846" y1="40.2119" x2="15.2846" y2="50.5662" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3F3AD" />
                          <stop offset="1" stop-color="#80C837" />
                        </linearGradient>
                      </defs>
                    </svg>
                  , title: "Fast Delivery"
                }
              ].map((feature, index) => (
                <div key={index} className="!flex !flex-col !items-center !gap-2">
                  <div className="!w-15 !h-15">
                    {feature.icon}
                  </div>
                  <p className="!text-[#5C7132] !text-sm">{feature.title}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default Homepage;